/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum VoucherType {
    Unique = 'Unique',
    Reusable = 'Reusable',
}

export enum VoucherCodeStatus {
    Active = 'Active',
    Suspend = 'Suspend',
    InActive = 'InActive',
    Expired = 'Expired',
    Close = 'Close',
}

export enum SyncType {
    RedisToSql = 'RedisToSql',
    SqlToRedis = 'SqlToRedis',
}

export enum SupplyType {
    Consignment = 'Consignment',
    Retail = 'Retail',
    Gift = 'Gift',
}

export enum StockType {
    Retail = 'Retail',
    Consign = 'Consign',
    CrossDocking = 'CrossDocking',
    ShipBySeller = 'ShipBySeller',
}

export enum SearchItemType {
    Product = 'Product',
    Category = 'Category',
    Brand = 'Brand',
}

export enum PromotionStatus {
    Active = 'Active',
    Inactive = 'Inactive',
    Expired = 'Expired',
    Close = 'Close',
    Suspend = 'Suspend',
}

export enum PromotionOfferType {
    FixInPurchasePrice = 'FixInPurchasePrice',
    PercentageInPurchasePrice = 'PercentageInPurchasePrice',
    FreeShipping = 'FreeShipping',
    Gift = 'Gift',
}

export enum PromotionOfferDueType {
    InPurchase = 'InPurchase',
    PostPurchase = 'PostPurchase',
}

export enum ProductListSort {
    MostVisited = 'MostVisited',
    Cheapest = 'Cheapest',
    MostExpensive = 'MostExpensive',
    Newest = 'Newest',
}

export enum PricingRuleType {
    Commercial = 'Commercial',
    Vendor = 'Vendor',
    Dumping = 'Dumping',
}

export enum PricingRuleStatus {
    Salable = 'Salable',
    OutOfStock = 'OutOfStock',
    Expired = 'Expired',
    Inactive = 'Inactive',
    Archive = 'Archive',
    Suspend = 'Suspend',
}

export enum LotStatus {
    Salable = 'Salable',
    OutOfStock = 'OutOfStock',
    Archive = 'Archive',
    Suspend = 'Suspend',
}

export enum LotIssuerReferenceType {
    InboundEvent = 'InboundEvent',
    Vca = 'Vca',
    VendorAssignment = 'VendorAssignment',
}

export enum CartItemChangeType {
    PriceIncrease = 'PriceIncrease',
    QtyDecrease = 'QtyDecrease',
    OutOfStock = 'OutOfStock',
    GiftRemoved = 'GiftRemoved',
    PromotionRemoved = 'PromotionRemoved',
    ItemProposalChange = 'ItemProposalChange',
    GiftAdd = 'GiftAdd',
    GiftEdit = 'GiftEdit',
}

export enum BatchImportProcessStatus {
    WaitForProcess = 'WaitForProcess',
    InProcess = 'InProcess',
    Finished = 'Finished',
}

export enum AvailableToPurchaseFlag {
    Pharmacy = 'Pharmacy',
    LegallyRestricted = 'LegallyRestricted',
    Gold = 'Gold',
    PromotionExcluded = 'PromotionExcluded',
}

export enum AnalyticsTagType {
    SearchBox = 'SearchBox',
    SearchPLP = 'SearchPLP',
    CategoryPLP = 'CategoryPLP',
    BrandPLP = 'BrandPLP',
    TagPLP = 'TagPLP',
    BrandCategoryPLP = 'BrandCategoryPLP',
    FavoritePLP = 'FavoritePLP',
    ComplementaryPDP = 'ComplementaryPDP',
    SimilarPDP = 'SimilarPDP',
    AdPLP = 'AdPLP',
    BrandList = 'BrandList',
    CountPLP = 'CountPLP',
    PriceRangesPLP = 'PriceRangesPLP',
    VendorSearch = 'VendorSearch',
}

export type ActionResult = object

export interface AddAtpUnsalableQtyViewModel {
    /** @format int32 */
    qty?: number
    /**
     * @minLength 5
     * @maxLength 36
     */
    referenceId: string
    partiallyEnable: boolean
}

export interface AddPricingRequestRequest {
    title?: string | null
    /** @format double */
    minDiscount: number
    /** @format double */
    maxDiscount: number
    /** @format double */
    desiredMargin: number
    /** @format int64 */
    desiredGmv: number
    inventoryAgeEffects: InventoryAgeEffect
    stockOutDaysEffect: StockOutDaysEffect
    brandEffects: BrandEffect[]
    processDescription?: string | null
}

export interface AddPricingRequestViewModel {
    title?: string | null
    /** @format date-time */
    createdAt?: string
    /** @format double */
    minDiscount?: number
    /** @format double */
    maxDiscount?: number
    /** @format double */
    desiredMargin?: number
    /** @format int64 */
    desiredGmv?: number
    inventoryAgeEffects?: InventoryAgeEffect
    stockOutDaysEffect?: StockOutDaysEffect
    brandEffects?: BrandEffect[] | null
    /** @format int32 */
    processStatus?: number
    processDescription?: string | null
}

export interface AddPricingRequestViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: AddPricingRequestViewModel
}

export interface AddToCartRequest {
    /** @minLength 1 */
    atpId: string
    /** @minLength 32 */
    itemProposalId: string
    /**
     * @format int32
     * @min 1
     * @max 2147483647
     */
    qty?: number
}

export interface AddToWishlistRequest {
    /** @minLength 1 */
    productId: string
}

export interface AddVoucherToCartRequest {
    /** @minLength 3 */
    code: string
}

export interface ApplicationConfigurationViewModel {
    /** @format int64 */
    freeShipmentCartMinPrice?: number
    /** @format int64 */
    packagingCost?: number
    /** @format int64 */
    maxImageSizeInBytes?: number
}

export interface ApplicationConfigurationViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: ApplicationConfigurationViewModel
}

export interface AtpChangeEvent {
    atpId?: AvailableToPurchaseId
    productId?: ProductId
    isSalable?: boolean
    variantNameEn?: string | null
    variantNameFa?: string | null
    /** @format int64 */
    basePrice?: number | null
    /** @format int64 */
    salesPrice?: number | null
    stockType?: StockType
    /** @format int32 */
    discountPercent?: number | null
    /** @format int64 */
    discountPrice?: number | null
}

export interface AtpChangeItemProposalEvent {
    productId?: ProductId
    atpId?: AvailableToPurchaseId
}

export interface AtpListItemByFlagViewModel {
    atpId?: string | null
    productId?: string | null
    variantNameFa?: string | null
}

export interface AtpListItemByFlagViewModelKibaPaginationViewModel {
    /** @format int32 */
    totalCount?: number
    /** @format int32 */
    pageNumber?: number
    /** @format int32 */
    pageSize?: number
    items?: AtpListItemByFlagViewModel[] | null
}

export interface AtpListItemByFlagViewModelKibaPaginationViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: AtpListItemByFlagViewModelKibaPaginationViewModel
}

export interface AuditRegisterReminderRequest {
    /** @format uuid */
    promotionId?: string
    name?: string | null
    dueTime?: string | null
    period?: string | null
}

export interface AvailableLotsViewModel {
    lotId?: string | null
    /** @format int32 */
    salableQty?: number
}

export interface AvailableToPurchaseEntityViewModel {
    /** @format int32 */
    id?: number
    variantNameFa?: string | null
    variantNameEn?: string | null
    code?: string | null
    availableLots?: LotEntityViewModel[] | null
}

export interface AvailableToPurchaseEntityViewModelKibaPaginationViewModel {
    /** @format int32 */
    totalCount?: number
    /** @format int32 */
    pageNumber?: number
    /** @format int32 */
    pageSize?: number
    items?: AvailableToPurchaseEntityViewModel[] | null
}

export interface AvailableToPurchaseEntityViewModelKibaPaginationViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: AvailableToPurchaseEntityViewModelKibaPaginationViewModel
}

export interface AvailableToPurchaseId {
    /** @format int32 */
    value?: number
}

export interface BatchImportPricingRuleListItemViewModel {
    /** @format int32 */
    id?: number
    title?: string | null
    /** @format date-time */
    createdAt?: string
    processStatus?: BatchImportProcessStatus
    /** @format date-time */
    startedAt?: string | null
    /** @format date-time */
    finishedAt?: string | null
    /** @format int32 */
    rowCount?: number
    /** @format int32 */
    successCount?: number
    /** @format int32 */
    failureCount?: number
}

export interface BatchImportPricingRuleListItemViewModelKibaPaginationViewModel {
    /** @format int32 */
    totalCount?: number
    /** @format int32 */
    pageNumber?: number
    /** @format int32 */
    pageSize?: number
    items?: BatchImportPricingRuleListItemViewModel[] | null
}

export interface BatchImportPricingRuleListItemViewModelKibaPaginationViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: BatchImportPricingRuleListItemViewModelKibaPaginationViewModel
}

export interface BooleanActionResult {
    result?: ActionResult
    value?: boolean
}

export interface BooleanActionResultSuccessEnvelop {
    isSuccess?: boolean
    data?: BooleanActionResult
}

export interface BooleanSuccessEnvelop {
    isSuccess?: boolean
    data?: boolean
}

export interface BrandEffect {
    brandId?: string | null
    /** @format float */
    maxDiscount?: number
}

export interface BrandFacetViewModel {
    displayNameFa?: string | null
    displayNameEn?: string | null
    key?: string | null
    /** @format int32 */
    count?: number
    isSelected?: boolean
}

export interface BrandId {
    /** @format int32 */
    value?: number
}

export interface BrandItemViewModel {
    id?: string | null
    slug?: string | null
    nameEn?: string | null
    nameFa?: string | null
    logoUrl?: string | null
}

export interface BrandListingItemViewModel {
    id?: string | null
    slug?: string | null
    nameFa?: string | null
    nameEn?: string | null
    logoUrl?: string | null
}

export interface BrandListingItemViewModelKibaPaginationViewModel {
    /** @format int32 */
    totalCount?: number
    /** @format int32 */
    pageNumber?: number
    /** @format int32 */
    pageSize?: number
    items?: BrandListingItemViewModel[] | null
}

export interface BrandListingItemViewModelKibaPaginationViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: BrandListingItemViewModelKibaPaginationViewModel
}

export interface BrandMenuViewModel {
    bestSellingBrands?: BrandItemViewModel[] | null
    topBrands?: BrandItemViewModel[] | null
    otherBrands?: BrandItemViewModel[] | null
}

export interface BreadcrumbBrandCategoryViewModel {
    title?: string | null
    slug?: string | null
}

export interface CartItemChangeBaseViewModel {
    type?: CartItemChangeType
    /** @format int64 */
    increasedPrice?: number | null
    /** @format int32 */
    qtyDiff?: number | null
    /** @format int32 */
    giftId?: number | null
    promotion?: CartPromotionViewModel
}

export interface CartItemChangedDataViewModel {
    item?: CartItemViewModel
    change?: CartItemChangeBaseViewModel
}

export interface CartItemViewModel {
    /** @format uuid */
    id?: string
    productName?: string | null
    brandName?: string | null
    productSlug?: string | null
    colorName?: string | null
    productImageUrl?: string | null
    colorImageUrl?: string | null
    colorHexCode?: string | null
    pricingGift?: boolean
    promotionOffer?: boolean
    gift?: boolean
    /** @format int64 */
    basePrice?: number
    /** @format int64 */
    salesPrice?: number
    /** @format int32 */
    qty?: number
    /** @format int32 */
    limit?: number | null
    atpId?: string | null
    /** @format int64 */
    discountPercent?: number
    categoryLevel1?: string | null
    categoryLevel2?: string | null
    categoryLevel3?: string | null
    parentItemId?: string | null
    vendorId?: string | null
    flags?: string | null
    shipBySeller?: boolean
    weightUnit?: string | null
    /** @format double */
    weighValue?: number | null
    /** @format int32 */
    packageWeight?: number | null
}

export interface CartPromotionViewModel {
    title?: string | null
    /** @format int64 */
    discount?: number | null
    offerType?: PromotionOfferType
    /** @format int32 */
    gift?: number | null
}

export interface CartViewModel {
    id?: string | null
    items?: CartItemViewModel[] | null
    /** @format int64 */
    totalPrice?: number
    /** @format int64 */
    totalSalesPrice?: number
    /** @format int64 */
    totalCartDiscount?: number
    /** @format int64 */
    totalEffectivePrice?: number
    /** @format int64 */
    totalItemDiscount?: number
    /** @format int32 */
    itemCount?: number
    /** @format int32 */
    sumOfQty?: number
    changes?: CartItemChangedDataViewModel[] | null
    voucher?: CartVoucherViewModel
    /** @format double */
    leadTimeInDay?: number
    promotion?: CartPromotionViewModel
}

export interface CartViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: CartViewModel
}

export interface CartVoucherViewModel {
    code?: string | null
}

export interface CategoryChangeEvent {
    categoryId?: string | null
    categoryName?: string | null
}

export interface CategoryFacetViewModel {
    displayNameFa?: string | null
    displayNameEn?: string | null
    key?: string | null
    /** @format int32 */
    count?: number
    isSelected?: boolean
    breadcrumb?: CategoryLevel[] | null
    children?: CategoryFacetViewModel[] | null
}

export interface CategoryLevel {
    /** @format int32 */
    level?: number
    id?: string | null
    slug?: string | null
    nameFa?: string | null
    nameEn?: string | null
}

export interface CategoryViewModel {
    id?: string | null
    slug?: string | null
    nameFa?: string | null
}

export interface ClickSearchItemRequest {
    /** @format uuid */
    userToken: string
    docId: string | null
    queryId: string | null
    type?: SearchItemType
    /** @format int32 */
    position?: number
}

export interface ColorFacetViewModel {
    displayNameFa?: string | null
    displayNameEn?: string | null
    key?: string | null
    /** @format int32 */
    count?: number
    isSelected?: boolean
    imageUrl?: string | null
}

export interface CommentListViewModel {
    id?: string | null
    userName?: string | null
    description?: string | null
    imageUrl?: string | null
    /** @format int32 */
    likesCount?: number
    /** @format date-time */
    createdAt?: string
}

export interface CommentListViewModelKibaPaginationViewModel {
    /** @format int32 */
    totalCount?: number
    /** @format int32 */
    pageNumber?: number
    /** @format int32 */
    pageSize?: number
    items?: CommentListViewModel[] | null
}

export interface CommentListViewModelKibaPaginationViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: CommentListViewModelKibaPaginationViewModel
}

export interface CostDimensionInfoViewModel {
    costCenter?: string | null
    costType?: string | null
    campaign?: string | null
}

export interface CreateCrmPromotionRequestViewModel {
    /**
     * @minLength 5
     * @maxLength 256
     */
    title: string
    /** @format date-time */
    to: string
    /** @format int64 */
    amount: number
    /** @minLength 1 */
    costType: string
    /** @format int64 */
    minPrice?: number | null
    campaign?: string | null
}

export interface CreateCrmPromotionViewModel {
    promotion?: PromotionViewModel
    uniqueVoucherCode?: UniqueVoucherViewModel
}

export interface CreateCrmPromotionViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: CreateCrmPromotionViewModel
}

export interface CreateFixPricePromotionRequestViewModel {
    cart?: PromotionCartConditionViewModel
    userSegment?: PromotionUserSegmentConditionViewModel
    trackingData?: PromotionUserTrackingDataConditionViewModel
    cartItems?: PromotionCartItemsSpecificationConditionRequestViewModel
    voucherId?: string | null
    /** @format date-time */
    from?: string
    /** @format date-time */
    to?: string
    /**
     * @format int32
     * @min 1
     * @max 2147483647
     */
    usableCount?: number
    /**
     * @minLength 5
     * @maxLength 256
     */
    title: string
    costDimensionInfo: CostDimensionInfoViewModel
    hasKey: boolean
    /** @format int64 */
    amount?: number
}

export interface CreateFreeShippingPromotionRequestViewModel {
    cart?: PromotionCartConditionViewModel
    userSegment?: PromotionUserSegmentConditionViewModel
    trackingData?: PromotionUserTrackingDataConditionViewModel
    cartItems?: PromotionCartItemsSpecificationConditionRequestViewModel
    voucherId?: string | null
    /** @format date-time */
    from?: string
    /** @format date-time */
    to?: string
    /**
     * @format int32
     * @min 1
     * @max 2147483647
     */
    usableCount?: number
    /**
     * @minLength 5
     * @maxLength 256
     */
    title: string
    costDimensionInfo: CostDimensionInfoViewModel
    hasKey: boolean
}

export interface CreateGiftPromotionRequestViewModel {
    cart?: PromotionCartConditionViewModel
    userSegment?: PromotionUserSegmentConditionViewModel
    trackingData?: PromotionUserTrackingDataConditionViewModel
    cartItems?: PromotionCartItemsSpecificationConditionRequestViewModel
    voucherId?: string | null
    /** @format date-time */
    from?: string
    /** @format date-time */
    to?: string
    /**
     * @format int32
     * @min 1
     * @max 2147483647
     */
    usableCount?: number
    /**
     * @minLength 5
     * @maxLength 256
     */
    title: string
    costDimensionInfo: CostDimensionInfoViewModel
    hasKey: boolean
    /** @format int32 */
    giftAtpId: number
}

export interface CreateOrderRequest {
    /** @format int64 */
    timeSlotId?: number | null
    /** @format int64 */
    addressId?: number
    /** @format int64 */
    shippingMethodId?: number | null
    /** @format int64 */
    distributionCenterId?: number | null
    paymentMethodType?: string | null
}

export interface CreateOrderViewModel {
    paymentUrl?: string | null
}

export interface CreateOrderViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: CreateOrderViewModel
}

export interface CreatePercentagePricePromotionRequestViewModel {
    cart?: PromotionCartConditionViewModel
    userSegment?: PromotionUserSegmentConditionViewModel
    trackingData?: PromotionUserTrackingDataConditionViewModel
    cartItems?: PromotionCartItemsSpecificationConditionRequestViewModel
    voucherId?: string | null
    /** @format date-time */
    from?: string
    /** @format date-time */
    to?: string
    /**
     * @format int32
     * @min 1
     * @max 2147483647
     */
    usableCount?: number
    /**
     * @minLength 5
     * @maxLength 256
     */
    title: string
    costDimensionInfo: CostDimensionInfoViewModel
    hasKey: boolean
    /** @format int32 */
    percent?: number
    /** @format int64 */
    maxAmount?: number
}

export interface CreateReusableVoucherCommandViewModel {
    /**
     * @minLength 5
     * @maxLength 512
     */
    title: string
    /** @format date-time */
    from?: string
    /** @format date-time */
    to?: string
    /**
     * @format int32
     * @min 1
     * @max 2147483647
     */
    usableCount?: number
    /**
     * @minLength 1
     * @pattern ^(\w|\d){2,50}$
     */
    code: string
}

export interface CreateUniqueVoucherCommandViewModel {
    /**
     * @minLength 5
     * @maxLength 512
     */
    title: string
    /** @format date-time */
    from?: string
    /** @format date-time */
    to?: string
    /**
     * @format int32
     * @min 1
     * @max 2147483647
     */
    usableCount?: number
}

export interface DecreaseLotSalableQtyRequest {
    /** @format int32 */
    atpId: number
    /** @minLength 1 */
    lotId: string
    /** @format int32 */
    qty: number
    /** @minLength 1 */
    erpReference: string
    partiallyEnable: boolean
    /** @minLength 1 */
    requestType: string
}

export interface DecreaseLotSalableQtyViewModel {
    /** @format int32 */
    affectedQty?: number
    lots?: AvailableLotsViewModel[] | null
}

export interface DecreaseLotSalableQtyViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: DecreaseLotSalableQtyViewModel
}

export interface DefaultDiscountRuleViewModel {
    /** @format int32 */
    defaultDiscount?: number
    costInfo?: CostDimensionInfoViewModel
}

export interface Discount {
    /** @format int32 */
    stockOutThreshold?: number
    setting?: Setting
}

export interface DynamicFacetKeyViewModel {
    displayNameFa?: string | null
    displayNameEn?: string | null
}

export interface DynamicFacetViewModel {
    key?: DynamicFacetKeyViewModel
    values?: FacetValueViewModel[] | null
}

export interface EnvelopError {
    code?: string | null
    message?: string | null
    property?: string | null
    attemptedValue?: any
    details?: string | null
}

export interface Error {
    code?: string | null
    message?: string | null
}

export interface ErrorFailureEnvelop {
    isSuccess?: boolean
    errors?: IEnvelopError[] | null
    data?: Error
}

export interface FacetValueViewModel {
    displayNameFa?: string | null
    displayNameEn?: string | null
    key?: string | null
    /** @format int32 */
    count?: number
    isSelected?: boolean
}

export interface FacetsViewModel {
    colorFacets?: ColorFacetViewModel[] | null
    brandFacets?: BrandFacetViewModel[] | null
    priceFacet?: PriceFacetViewModel
    dynamicFacets?: DynamicFacetViewModel[] | null
    stockFacet?: StockFacetViewModel
    categories?: CategoryFacetViewModel[] | null
}

export interface FailureEnvelop {
    isSuccess?: boolean
    errors?: IEnvelopError[] | null
}

export interface FileStreamResultSuccessEnvelop {
    isSuccess?: boolean
    /** @format binary */
    data?: File | null
}

export interface GetAvailableLotsAtpData {
    /** @format int32 */
    atpId?: number
    lots?: GetAvailableLotsData[] | null
}

export interface GetAvailableLotsData {
    lotId?: string | null
    stockType?: string | null
    status?: string | null
    /** @format int32 */
    qty?: number
    /** @format int32 */
    unSalableQty?: number
    /** @format int32 */
    blockedQty?: number
    /** @format int32 */
    soldQty?: number
    /** @format int32 */
    reserveQty?: number
    /** @format int32 */
    salableQty?: number
    vendorId?: string | null
    /** @format double */
    basePrice?: number
    /** @format date-time */
    createdAt?: string
    /** @format date-time */
    receivedDate?: string
}

export interface GetAvailableLotsMeta {
    requestedAtpIds?: number[] | null
    /** @format int32 */
    countAtpIds?: number
    /** @format int32 */
    countLots?: number
}

export interface GetAvailableLotsResponse {
    data?: GetAvailableLotsAtpData[] | null
    meta?: GetAvailableLotsMeta
}

export interface GetBrandBySlugViewModel {
    id: string | null
    slug: string | null
    nameEn: string | null
    nameFa: string | null
    logoUrl?: string | null
    description?: string | null
    descriptionMeta?: string | null
    code?: string | null
    pageTitle?: string | null
}

export interface GetBrandBySlugViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: GetBrandBySlugViewModel
}

export interface GetBrandCategoryViewModel {
    brand: GetBrandBySlugViewModel
    category: GetCategoryBySlugViewModel
}

export interface GetBrandCategoryViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: GetBrandCategoryViewModel
}

export interface GetBrandMaxDiscountViewModel {
    brandId?: string | null
    brandNameFa?: string | null
    brandNameEn?: string | null
    /** @format double */
    maxDiscount?: number
    /** @format date-time */
    modifiedAt?: string
}

export interface GetBrandMaxDiscountViewModelKibaPaginationViewModel {
    /** @format int32 */
    totalCount?: number
    /** @format int32 */
    pageNumber?: number
    /** @format int32 */
    pageSize?: number
    items?: GetBrandMaxDiscountViewModel[] | null
}

export interface GetBrandMaxDiscountViewModelKibaPaginationViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: GetBrandMaxDiscountViewModelKibaPaginationViewModel
}

export interface GetCategoryBySlugViewModel {
    id: string | null
    parentId?: string | null
    nameFa: string | null
    nameEn: string | null
    imageUrl?: string | null
    slug: string | null
    description?: string | null
    descriptionMeta?: string | null
    pageTitle?: string | null
    keywords?: string | null
    breadcrumb: CategoryLevel[] | null
}

export interface GetCategoryBySlugViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: GetCategoryBySlugViewModel
}

export interface GetCrmPromotionListViewModel {
    id?: PromotionId
    title?: string | null
    voucherId?: VoucherId
    voucherCode?: string[] | null
    costType?: string | null
    campaignType?: string | null
    /** @format int64 */
    minPrice?: number | null
    /** @format int64 */
    amount?: number
    /** @format date-time */
    from?: string
    /** @format date-time */
    to?: string
    status?: PromotionStatus
}

export interface GetCrmPromotionListViewModelKibaPaginationViewModel {
    /** @format int32 */
    totalCount?: number
    /** @format int32 */
    pageNumber?: number
    /** @format int32 */
    pageSize?: number
    items?: GetCrmPromotionListViewModel[] | null
}

export interface GetCrmPromotionListViewModelKibaPaginationViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: GetCrmPromotionListViewModelKibaPaginationViewModel
}

export interface GetDefaultDefaultDiscountRuleViewModel {
    /** @format int32 */
    id?: number
    /** @format int32 */
    productId?: number
    defaultDiscount?: DefaultDiscountRuleViewModel
}

export interface GetDefaultDefaultDiscountRuleViewModelKibaPaginationViewModel {
    /** @format int32 */
    totalCount?: number
    /** @format int32 */
    pageNumber?: number
    /** @format int32 */
    pageSize?: number
    items?: GetDefaultDefaultDiscountRuleViewModel[] | null
}

export interface GetDefaultDefaultDiscountRuleViewModelKibaPaginationViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: GetDefaultDefaultDiscountRuleViewModelKibaPaginationViewModel
}

export interface GetErpAtpItemListViewModel {
    id?: string | null
    lotNo?: string | null
    itemVariantId?: string | null
    vendorNo?: string | null
    vendorName?: string | null
    /** @format date-time */
    expectedReceivedDate?: string | null
    /** @format date-time */
    receivedDate?: string
    supplyType?: string | null
    /** @format int32 */
    qty?: number
    /** @format int32 */
    blocked?: number
    /** @format double */
    basePrice?: number
    /** @format double */
    directCost?: number
    /** @format date-time */
    createdAt?: string
    /** @format date-time */
    lastModifiedAt?: string | null
    /** @format int32 */
    entryNo?: number
    orderNo?: string | null
    /** @format double */
    unitAmount?: number
    /** @format double */
    unitDiscount?: number
    approved?: boolean
    isBlocked?: boolean
    /** @format double */
    invoiceDiscountPrct?: number | null
    /** @format double */
    discount?: number | null
    /** @format double */
    directUnitCostWithMargin?: number
    /** @format double */
    lineDiscountPrct?: number | null
    /** @format double */
    vatPrct?: number
    /** @format double */
    contractMargin?: number | null
    approvable?: boolean
    variantName?: string | null
}

export interface GetErpAtpItemListViewModelKibaPaginationViewModel {
    /** @format int32 */
    totalCount?: number
    /** @format int32 */
    pageNumber?: number
    /** @format int32 */
    pageSize?: number
    items?: GetErpAtpItemListViewModel[] | null
}

export interface GetErpAtpItemListViewModelKibaPaginationViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: GetErpAtpItemListViewModelKibaPaginationViewModel
}

export interface GetPaymentOptionsViewModel {
    title?: string | null
    description?: string | null
    logoUrl?: string | null
    isDefault?: boolean
    /** @format int64 */
    amount?: number
    /** @format int64 */
    credit?: number
    paymentMethodType?: string | null
}

export interface GetPaymentOptionsViewModelArraySuccessEnvelop {
    isSuccess?: boolean
    data?: GetPaymentOptionsViewModel[] | null
}

export interface GetPriceRangeViewModel {
    /** @format int64 */
    fromPrice?: number
    /** @format int64 */
    toPrice?: number
    path: string | null
}

export interface GetPriceRangeViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: GetPriceRangeViewModel
}

export interface GetPricingRequestResultViewModel {
    /** @format int32 */
    id?: number
    /** @format int32 */
    pricingRequestId?: number
    /** @format int32 */
    atpId?: number
    category2?: string | null
    category3?: string | null
    brand?: string | null
    grade?: string | null
    /** @format int32 */
    currentStock?: number
    /** @format int64 */
    firstCostPrice?: number
    /** @format int64 */
    lastCostPrice?: number
    /** @format int64 */
    firstBasePrice?: number
    /** @format int64 */
    lastBasePrice?: number
    /** @format double */
    averageQuantityDailySales?: number
    /** @format int64 */
    averageDailySalesPrice?: number
    /** @format int32 */
    oldestInventoryAge?: number
    /** @format int32 */
    newestInventoryAge?: number
    /** @format double */
    newCustomerRatio?: number
    /** @format int32 */
    totalCustomers?: number
    /** @format double */
    averageDiscount?: number
    /** @format double */
    minDiscount?: number
    /** @format double */
    marginBeforeDiscount?: number
    /** @format double */
    maxDiscount?: number
    /** @format double */
    stockOutDays?: number
    acquisitionCandidate?: boolean
    acquisitionSelected?: boolean
    /** @format double */
    margin?: number
    /** @format double */
    optimizedDiscount?: number
    /** @format int64 */
    finalPrice?: number
    /** @format date-time */
    createdAt?: string
}

export interface GetPricingRequestResultViewModelKibaPaginationViewModel {
    /** @format int32 */
    totalCount?: number
    /** @format int32 */
    pageNumber?: number
    /** @format int32 */
    pageSize?: number
    items?: GetPricingRequestResultViewModel[] | null
}

export interface GetPricingRequestResultViewModelKibaPaginationViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: GetPricingRequestResultViewModelKibaPaginationViewModel
}

export interface GetPricingRequestsViewModel {
    /** @format int32 */
    id?: number
    /** @format uuid */
    userId?: string
    title?: string | null
    /** @format date-time */
    createdAt?: string
    /** @format date-time */
    modifiedAt?: string
    /** @format double */
    minDiscount?: number
    /** @format double */
    maxDiscount?: number
    /** @format double */
    desiredMargin?: number
    /** @format int64 */
    desiredGmv?: number
    inventoryAgeEffects?: InventoryAgeEffect
    stockOutDaysEffect?: StockOutDaysEffect
    brandEffects?: BrandEffect[] | null
    /** @format int32 */
    processStatus?: number
    processDescription?: string | null
}

export interface GetPricingRequestsViewModelKibaPaginationViewModel {
    /** @format int32 */
    totalCount?: number
    /** @format int32 */
    pageNumber?: number
    /** @format int32 */
    pageSize?: number
    items?: GetPricingRequestsViewModel[] | null
}

export interface GetPricingRequestsViewModelKibaPaginationViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: GetPricingRequestsViewModelKibaPaginationViewModel
}

export interface GetProductItemProposalQueryItemViewModel {
    productId?: string | null
    /** @format int64 */
    basePrice?: number
    /** @format int64 */
    salesPrice?: number
    flags?: string | null
    hasStock?: boolean
}

export interface GetProductItemProposalQueryItemViewModelArraySuccessEnvelop {
    isSuccess?: boolean
    data?: GetProductItemProposalQueryItemViewModel[] | null
}

export interface GetProductListViewModel {
    queryId?: string | null
    sort?: ProductListSort
    products?: ProductListViewModelKibaPaginationViewModel
    facets?: FacetsViewModel
}

export interface GetProductListViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: GetProductListViewModel
}

export interface GetSubCartViewModel {
    /** @format int64 */
    totalPrice?: number
    /** @format int64 */
    totalItemDiscount?: number
    /** @format int64 */
    totalCartDiscount?: number
    /** @format int64 */
    totalEffectivePrice?: number
    promotion?: CartPromotionViewModel
    subCarts?: SubCartViewModel[] | null
    changes?: CartItemChangedDataViewModel[] | null
}

export interface GetSubCartViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: GetSubCartViewModel
}

export interface GetTagBySlugViewModel {
    id: string | null
    nameFa: string | null
    nameEn: string | null
    imageUrl?: string | null
    slug: string | null
    description?: string | null
    descriptionMeta?: string | null
    pageTitle?: string | null
}

export interface GetTagBySlugViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: GetTagBySlugViewModel
}

export interface GoldBasePrice {
    /** @format int64 */
    amount?: number
    /** @format int64 */
    goldPrice?: number
    /** @format double */
    goldValue?: number
    /** @format double */
    makingFeePercent?: number
    /** @format double */
    marginPercent?: number
    /** @format int64 */
    nonGoldComponentCost?: number
    /** @format double */
    vatPercent?: number
    /** @format date-time */
    goldPriceExpiration?: string
    /** @format double */
    makingFee?: number
    /** @format double */
    margin?: number
    /** @format double */
    vat?: number
}

export interface GoldBasePriceViewModel {
    /** @format int64 */
    goldPrice?: number
    /** @format double */
    goldValue?: number
    /** @format double */
    makingFeePercent?: number
    /** @format double */
    marginPercent?: number
    /** @format int64 */
    nonGoldComponentCost?: number
    /** @format double */
    vatPercent?: number
    /** @format date-time */
    goldPriceExpiration?: string
    /** @format int64 */
    makingFee?: number
    /** @format int64 */
    margin?: number
    /** @format int64 */
    vat?: number
}

export interface GoldPriceViewModel {
    /** @format int64 */
    price?: number
    /** @format date-time */
    expiredAt?: string
}

export interface IEnvelopError {
    code?: string | null
    message?: string | null
    property?: string | null
    attemptedValue?: any
    details?: string | null
}

export interface IncreaseLotSalableQtyRequest {
    /** @format int32 */
    atpId: number
    /** @minLength 1 */
    lotId: string
    /** @format int32 */
    qty: number
    /** @minLength 1 */
    erpReference: string
    /** @minLength 1 */
    requestType: string
}

export interface Int32SuccessEnvelop {
    isSuccess?: boolean
    /** @format int32 */
    data?: number
}

export interface InventoryAgeEffect {
    lowerInventoryAgeEffect?: InventoryAgeEffectDetail
    upperInventoryAgeEffect?: InventoryAgeEffectDetail
}

export interface InventoryAgeEffectDetail {
    /** @format int32 */
    ageThreshold?: number
    /** @format float */
    minDiscount?: number
}

export interface ItemProposal {
    id?: ItemProposalId
    lotNumber?: LotId
    pricingRuleId?: PricingRuleId
    vendor?: LotVendor
    stockType?: StockType
    /** @format int64 */
    basePrice?: number
    /** @format int64 */
    salesPrice?: number
    /** @format int32 */
    limit?: number | null
    /** @format date-span */
    leadTime?: string
    isSalable?: boolean
    /** @format int32 */
    qty?: number
    gift?: AvailableToPurchaseId
    /** @format int64 */
    directCost?: number
    /** @format int64 */
    debt?: number
    /** @format int64 */
    profit?: number
    /** @format double */
    margin?: number
    atpId?: AvailableToPurchaseId
    costInfo?: ItemProposalCostDimension
    pricingRuleType?: PricingRuleType
    productId?: ProductId
    atpFlags?: AvailableToPurchaseFlag
    /** @format int64 */
    vendorPrice?: number | null
    /** @format double */
    vendorCommission?: number | null
    goldBasePrice?: GoldBasePrice
    vendorAtpCode?: string | null
    /** @format int64 */
    discountPrice?: number
    /** @format int32 */
    discountPercent?: number
}

export interface ItemProposalCostDimension {
    costCenter?: string | null
    costType?: string | null
    campaign?: string | null
    /** @format int64 */
    discount?: number
}

export interface ItemProposalId {
    value?: string | null
}

export interface ItemProposalListSuccessEnvelop {
    isSuccess?: boolean
    data?: ItemProposal[] | null
}

export interface ItemProposalViewModel {
    id?: ItemProposalId
    lotNumber?: string | null
    /** @format uuid */
    pricingRuleId?: string
    vendor?: LotVendor
    stockType?: StockType
    /** @format int64 */
    basePrice?: number
    /** @format int64 */
    salesPrice?: number
    /** @format int32 */
    limit?: number | null
    /** @format date-span */
    leadTime?: string
    isSalable?: boolean
    /** @format int32 */
    qty?: number
    /** @format int32 */
    gift?: number | null
    /** @format int64 */
    directCost?: number
    /** @format int64 */
    debt?: number
    /** @format int64 */
    profit?: number
    /** @format double */
    margin?: number
    costInfo?: ItemProposalCostDimension
    pricingRuleType?: PricingRuleType
    /** @format int32 */
    productId?: number
    /** @format int64 */
    discountPrice?: number
    /** @format int32 */
    discountPercent?: number
}

export interface ItemProposalViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: ItemProposalViewModel
}

export interface LineItemViewModel {
    /** @format int32 */
    quantity?: number
    /** @format int64 */
    price?: number
    /** @format int64 */
    basePrice?: number
    isPromotionOffer?: boolean
    hasPricingGift?: boolean
    /** @format int64 */
    unitDiscount?: number
    shipBySeller?: boolean
    product?: OrderProductViewModel
    /** @format int32 */
    promotionShareAmount?: number | null
}

export interface LotEntityViewModel {
    id?: string | null
    vendor?: VendorLotViewModel
    /** @format date-span */
    leadTime?: string
    stockType?: StockType
    /** @format int32 */
    qty?: number
    /** @format int32 */
    unSalableQty?: number
    /** @format int32 */
    blockedQty?: number
    /** @format int32 */
    soldQty?: number
    /** @format int32 */
    reserveQty?: number
    status?: LotStatus
    /** @format int64 */
    basePrice?: number
    /** @format date-time */
    archivedAt?: string | null
    /** @format date-time */
    receivedDate?: string | null
    issuer?: LotIssuerReferenceViewModel
    /** @format int32 */
    salableQty?: number
    pricingRules?: PricingRuleEntityViewModel[] | null
    vendorAtpCode?: string | null
}

export interface LotId {
    value?: string | null
}

export interface LotIssuerReferenceViewModel {
    type?: LotIssuerReferenceType
    id?: string | null
}

export interface LotVendor {
    vendorId?: VendorId
    vendorName?: string | null
    displayName?: string | null
}

export interface MenuViewModel {
    brand?: BrandMenuViewModel
    promotedUrl?: string | null
    magazineUrl?: string | null
}

export interface MenuViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: MenuViewModel
}

export interface OrderCategoryLevelViewModel {
    level1?: CategoryViewModel
    level2?: CategoryViewModel
    level3?: CategoryViewModel
}

export interface OrderColorViewModel {
    imageUrl?: string | null
    name?: string | null
}

export interface OrderProductViewModel {
    /** @format int32 */
    productId?: number
    name?: string | null
    color?: OrderColorViewModel
    categoryLevels?: OrderCategoryLevelViewModel
    brand?: string | null
}

export interface OrderViewModel {
    orderId?: string | null
    orderNumber?: string | null
    /** @format int64 */
    shippingCost?: number
    /** @format int64 */
    finalTotalPrice?: number
    coupon?: string | null
    cartId?: string | null
    /** @format int64 */
    totalPromotionAmount?: number | null
    promotionOfferType?: PromotionOfferType
    promotionTitle?: string | null
    voucherCode?: string | null
    subOrder?: SubOrderViewModel
}

export type PaymentCallbackViewModel = object

export interface PaymentCallbackViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: PaymentCallbackViewModel
}

export interface PaymentFinalStatusViewModel {
    /** @format int64 */
    amount?: number
    gateway?: string | null
    isPaidSuccessfully?: boolean
    /** @format int32 */
    shipmentCount?: number
    order?: OrderViewModel
}

export interface PaymentFinalStatusViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: PaymentFinalStatusViewModel
}

export interface PointOfPurchaseShopViewModel {
    itemProposalId?: string | null
    atpId?: string | null
    productName?: string | null
    brandName?: string | null
    colorName?: string | null
    productImageUrl?: string | null
    /** @format int64 */
    basePrice?: number
    /** @format int64 */
    salesPrice?: number
    /** @format int64 */
    discountPrice?: number
    /** @format int32 */
    discountPercent?: number
}

export interface PointOfPurchaseShopViewModelListSuccessEnvelop {
    isSuccess?: boolean
    data?: PointOfPurchaseShopViewModel[] | null
}

export interface PointOfPurchaseViewModel {
    variantId?: string | null
    imageUrl?: string | null
    productName?: string | null
    brandName?: string | null
    colorName?: string | null
}

export interface PointOfPurchaseViewModelKibaPaginationViewModel {
    /** @format int32 */
    totalCount?: number
    /** @format int32 */
    pageNumber?: number
    /** @format int32 */
    pageSize?: number
    items?: PointOfPurchaseViewModel[] | null
}

export interface PointOfPurchaseViewModelKibaPaginationViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: PointOfPurchaseViewModelKibaPaginationViewModel
}

export interface PriceFacetViewModel {
    /** @format int32 */
    fromPrice?: number | null
    /** @format int32 */
    toPrice?: number | null
    /** @format int32 */
    selectedFromPrice?: number | null
    /** @format int32 */
    selectedToPrice?: number | null
}

export interface PricingRuleEntityViewModel {
    /** @format uuid */
    id?: string
    /** @format int64 */
    salesPrice?: number
    /** @format date-time */
    from?: string
    /** @format date-time */
    to?: string
    /** @format date-time */
    archivedAt?: string | null
    /** @format date-time */
    outOfStockTime?: string | null
    /** @format int32 */
    qty?: number
    /** @format int32 */
    soldQty?: number
    /** @format int32 */
    reserveQty?: number
    /** @format int32 */
    unSalableQty?: number
    /**
     * Limit of items that user can buy in one order
     * @format int32
     */
    limit?: number | null
    status?: PricingRuleStatus
    /** @format int32 */
    gift?: number | null
    /** @format int32 */
    availableQty?: number
    type?: PricingRuleType
}

export interface PricingRuleId {
    /** @format uuid */
    value?: string
}

export interface ProductAdViewModel {
    /** @format uuid */
    bidId?: string
    vendorId?: string | null
    /** @format int32 */
    index?: number
}

export interface ProductBrandViewModel {
    /** @format int32 */
    id?: number
    nameFa?: string | null
    nameEn?: string | null
    slug?: string | null
    consideration?: string | null
}

export interface ProductChangeEvent {
    productId?: ProductId
    isPublished?: boolean
    productName?: string | null
    brandId?: BrandId
    brandName?: string | null
    slug?: string | null
    categoryLevel1?: CategoryChangeEvent
    categoryLevel2?: CategoryChangeEvent
    categoryLevel3?: CategoryChangeEvent
    mainImageUrl?: string | null
    /** @format date-time */
    lastModifiedAt?: string | null
    isDiscontinued?: boolean
}

export interface ProductForEmallsViewModel {
    id?: string | null
    title?: string | null
    /** @format int64 */
    price?: number
    /** @format int64 */
    old_price?: number
    category?: string | null
    color?: string | null
    guarantee?: string | null
    is_available?: boolean
    url?: string | null
}

export interface ProductForTorobViewModel {
    title?: string | null
    subtitle?: string | null
    page_unique?: string | null
    /** @format int64 */
    current_price?: number
    /** @format int64 */
    old_price?: number
    availability?: string | null
    category_name?: string | null
    image_link?: string | null
    image_links?: string[] | null
    page_url?: string | null
    short_desc?: string | null
    spec?: Record<string, string>
    registry?: string | null
    guarantee?: string | null
    seller_city?: string | null
    seller_name?: string | null
    h1?: string | null
}

export interface ProductId {
    /** @format int32 */
    value?: number
}

export interface ProductImageViewModel {
    id?: string | null
    /** Absolute url */
    imageUrl?: string | null
}

export interface ProductListForEmallsViewModel {
    /** @format int32 */
    total_items?: number
    /** @format int32 */
    page_num?: number
    /** @format int32 */
    item_per_page?: number
    /** @format int32 */
    pages_count?: number
    products?: ProductForEmallsViewModel[] | null
}

export interface ProductListForTorobViewModel {
    /** @format int32 */
    count?: number
    /** @format int32 */
    max_pages?: number
    products?: ProductForTorobViewModel[] | null
}

export interface ProductListViewModel {
    id?: string | null
    nameFa?: string | null
    nameEn?: string | null
    hasStock?: boolean
    slug?: string | null
    imageUrl?: string | null
    /** @format int64 */
    basePrice?: number
    brand?: ProductBrandViewModel
    flags?: string | null
    /** @format int64 */
    discountPrice?: number
    /** @format int32 */
    discountPercent?: number
    /** @format int64 */
    effectivePrice?: number
    /** @format int32 */
    colorsCount?: number
    isSalable?: boolean
    ad?: ProductAdViewModel
    breadcrumb?: CategoryLevel[] | null
}

export interface ProductListViewModelKibaPaginationViewModel {
    /** @format int32 */
    totalCount?: number
    /** @format int32 */
    pageNumber?: number
    /** @format int32 */
    pageSize?: number
    items?: ProductListViewModel[] | null
}

export interface ProductListViewModelKibaPaginationViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: ProductListViewModelKibaPaginationViewModel
}

export interface ProductListViewModelListSuccessEnvelop {
    isSuccess?: boolean
    data?: ProductListViewModel[] | null
}

export interface ProductListViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: ProductListViewModel
}

export interface ProductVariantColorViewModel {
    id?: string | null
    name?: string | null
    /** Absolute URL */
    imageUrl?: string | null
    hexCode?: string | null
    images?: ProductVariantImageViewModel[] | null
}

export interface ProductVariantImageViewModel {
    id?: string | null
    colorId?: string | null
    /** Absolute URL */
    imageUrl?: string | null
}

export interface ProductVariantViewModel {
    id?: string | null
    itemProposalId?: string | null
    color?: ProductVariantColorViewModel
    weight?: ProductVariantWeightViewModel
    isSalable?: boolean
    /** @format int64 */
    basePrice?: number
    /** @format int64 */
    salesPrice?: number
    /** @format int64 */
    discountPrice?: number
    /** @format int32 */
    discountPercent?: number
    /** @format int32 */
    limit?: number | null
    /** @format int32 */
    leadTime?: number | null
    giftVariantNameFa?: string | null
    flags?: string | null
    vendorDisplayName?: string | null
    shipBySeller?: boolean
    goldBasePrice?: GoldBasePriceViewModel
}

export interface ProductVariantWeight {
    /** @format int32 */
    value?: number | null
    unit?: string | null
    /** @format int32 */
    packageWeight?: number | null
}

export interface ProductVariantWeightViewModel {
    /** @format double */
    value?: number
    unit?: string | null
    /** @format int32 */
    packageWeight?: number | null
}

export interface ProductVideoViewModel {
    id?: string | null
    /** Absolute URL */
    videoUrl?: string | null
    /** Absolute URL */
    coverImageUrl?: string | null
    /** Absolute URL */
    thumbnailImageUrl?: string | null
}

export interface ProductViewModel {
    id?: string | null
    slug?: string | null
    nameFa?: string | null
    nameEn?: string | null
    isPublished?: boolean
    isDiscontinued?: boolean
    isSalable?: boolean
    /** @format int64 */
    basePrice?: number
    /** @format int64 */
    salesPrice?: number | null
    /** @format int64 */
    discountPrice?: number | null
    /** @format int32 */
    discountPercent?: number | null
    /** @format double */
    rate?: number
    /** @format int32 */
    ratesCount?: number
    /** @format int32 */
    commentsCount?: number
    /** @format int32 */
    addedToWishListCount?: number
    mainImageUrl?: string | null
    pageTitle?: string | null
    pageH1?: string | null
    flags?: string | null
    brand?: ProductBrandViewModel
    breadcrumb?: CategoryLevel[] | null
    breadcrumbBrandCategory?: BreadcrumbBrandCategoryViewModel
    weight?: ProductVariantWeightViewModel
    descriptionMarkdown?: string | null
    howToUseMarkdown?: string | null
    descriptionMeta?: string | null
    descriptionHtmlEn?: string | null
    descriptionHtmlFa?: string | null
    howToUseHtml?: string | null
    images?: ProductImageViewModel[] | null
    videos?: ProductVideoViewModel[] | null
    variants?: ProductVariantViewModel[] | null
}

export interface ProductViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: ProductViewModel
}

export interface ProductWishlistViewModel {
    id?: string | null
    hasStock?: boolean
    nameEn?: string | null
    nameFa?: string | null
    slug?: string | null
    isSalable?: boolean
    imageUrl?: string | null
    /** @format int64 */
    basePrice?: number
    /** @format int64 */
    discountPrice?: number
    /** @format int32 */
    discountPercent?: number
    /** @format int64 */
    effectivePrice?: number
    /** @format int32 */
    colorsCount?: number
    brand?: ProductBrandViewModel
    categories?: CategoryViewModel[] | null
    flags?: string | null
}

export interface ProductWishlistViewModelKibaPaginationViewModel {
    /** @format int32 */
    totalCount?: number
    /** @format int32 */
    pageNumber?: number
    /** @format int32 */
    pageSize?: number
    items?: ProductWishlistViewModel[] | null
}

export interface ProductWishlistViewModelKibaPaginationViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: ProductWishlistViewModelKibaPaginationViewModel
}

export interface PromotionCartConditionViewModel {
    /** @format int64 */
    minPrice?: number | null
    /** @format int64 */
    maxPrice?: number | null
    /** @format int32 */
    minItems?: number | null
    /**
     * @format float
     * @min 1
     * @max 99
     */
    minMargin?: number | null
    /**
     * @format float
     * @min 1
     * @max 99
     */
    minItemMargin?: number | null
}

export interface PromotionCartItemsSpecificationConditionRequestViewModel {
    /**
     * @format int32
     * @min 1
     * @max 10
     */
    requiredItem: number
    /** @format int32 */
    categoryId?: number | null
    /** @format int32 */
    brandId?: number | null
    /** @format int32 */
    tagId?: number | null
}

export interface PromotionCartItemsSpecificationConditionViewModel {
    /** @format int32 */
    requiredItem?: number
    brand?: PromotionConditionBrandViewModel
    category?: PromotionConditionCategoryViewModel
    tag?: PromotionConditionTagViewModel
}

export interface PromotionConditionBrandViewModel {
    /** @format int32 */
    id?: number
    name?: string | null
}

export interface PromotionConditionCategoryViewModel {
    /** @format int32 */
    id?: number
    name?: string | null
}

export interface PromotionConditionTagViewModel {
    /** @format int32 */
    id?: number
    name?: string | null
}

export interface PromotionConditionViewModel {
    cart?: PromotionCartConditionViewModel
    voucher?: PromotionVoucherConditionViewModel
    userSegment?: PromotionUserSegmentConditionViewModel
    trackingData?: PromotionUserTrackingDataConditionViewModel
    cartItems?: PromotionCartItemsSpecificationConditionViewModel
}

export interface PromotionExamineFailedWithCartItemRequirementViewModel {
    /** @format int32 */
    requiredItem?: number
    brand?: string | null
    category?: string | null
    tag?: string | null
}

export interface PromotionExamineFailedWithMinCartPriceResponseViewModel {
    /** @format int64 */
    minPrice?: number
}

export interface PromotionGiftViewModel {
    /** @format int32 */
    atpId?: number
    title?: string | null
}

export interface PromotionId {
    /** @format uuid */
    value?: string
}

export interface PromotionIdSuccessEnvelop {
    isSuccess?: boolean
    data?: PromotionId
}

export interface PromotionImperfectViewModel {
    minCartPriceIssue?: PromotionExamineFailedWithMinCartPriceResponseViewModel
    cartItemRequirement?: PromotionExamineFailedWithCartItemRequirementViewModel
    displayMessage?: string | null
}

export interface PromotionImperfectViewModelFailureEnvelop {
    isSuccess?: boolean
    errors?: IEnvelopError[] | null
    data?: PromotionImperfectViewModel
}

export interface PromotionListItemViewModel {
    id?: string | null
    title?: string | null
    /** @format date-time */
    from?: string
    /** @format date-time */
    to?: string
    status?: PromotionStatus
    /** @format int32 */
    usableCount?: number
    /** @format int32 */
    reserveCount?: number
    /** @format int32 */
    settleCount?: number
    /** @format int32 */
    availableCount?: number
    offer?: PromotionOfferBaseViewModel
    voucher?: VoucherDtoViewModel
    cart?: PromotionCartConditionViewModel
    userSegment?: PromotionUserSegmentConditionViewModel
    trackingData?: PromotionUserTrackingDataConditionViewModel
    costInfo?: CostDimensionInfoViewModel
    cartItems?: PromotionCartItemsSpecificationConditionViewModel
    hasKey?: boolean
    usageUrl?: string | null
}

export interface PromotionListItemViewModelKibaPaginationViewModel {
    /** @format int32 */
    totalCount?: number
    /** @format int32 */
    pageNumber?: number
    /** @format int32 */
    pageSize?: number
    items?: PromotionListItemViewModel[] | null
}

export interface PromotionListItemViewModelKibaPaginationViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: PromotionListItemViewModelKibaPaginationViewModel
}

export interface PromotionOfferBaseViewModel {
    id?: string | null
    dueType?: PromotionOfferDueType
    type?: PromotionOfferType
    /** @format int64 */
    amount?: number
    /** @format int32 */
    percent?: number
    /** @format int64 */
    maxAmount?: number
    gift?: PromotionGiftViewModel
}

export interface PromotionUserSegmentConditionViewModel {
    /** @format date-time */
    registerDate?: string | null
    /** @format date-time */
    firstPurchaseDate?: string | null
    /** @format date-time */
    lastPurchaseDate?: string | null
    /** @format int32 */
    recency?: number | null
    /** @format int32 */
    orderTotalCount?: number | null
    /** @format int32 */
    orderRecentYearCount?: number | null
    /** @format int64 */
    aovRecentYear?: number | null
    /** @format int64 */
    ipoRecentYear?: number | null
    /** @format double */
    marginTotal?: number | null
    /** @format double */
    marginRecentYear?: number | null
    /** @format double */
    marginRecentThreeOrders?: number | null
    /** @format date */
    exactFirstPurchaseDate?: string | null
    /** @format date */
    exactLastPurchaseDate?: string | null
    /** @format int32 */
    exactOrderTotalCount?: number | null
}

export interface PromotionUserTrackingDataConditionViewModel {
    /** @maxLength 128 */
    utmId?: string | null
    /** @maxLength 128 */
    utmCampaign?: string | null
    /** @maxLength 128 */
    utmContent?: string | null
    /** @maxLength 128 */
    utmMedium?: string | null
    /** @maxLength 128 */
    utmSource?: string | null
    /** @maxLength 128 */
    utmTerm?: string | null
    referredUser?: boolean | null
}

export interface PromotionViewModel {
    id?: string | null
    condition?: PromotionConditionViewModel
    /** @format date-time */
    from?: string
    /** @format date-time */
    to?: string
    status?: PromotionStatus
    /** @format int32 */
    usableCount?: number
    /** @format int32 */
    reserveCount?: number
    /** @format int32 */
    settleCount?: number
    /** @format int32 */
    availableCount?: number
    offer?: PromotionOfferBaseViewModel
    title?: string | null
    costInfo?: CostDimensionInfoViewModel
    isDeleted?: boolean
    /** @format date-time */
    deletedAt?: string | null
    hasKey?: boolean
}

export interface PromotionViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: PromotionViewModel
}

export interface PromotionVoucherConditionViewModel {
    id?: string | null
}

export interface ReusableVoucherViewModel {
    /** @format int64 */
    id?: number
    title?: string | null
    /** @format date-time */
    from?: string
    /** @format date-time */
    to?: string
    status?: VoucherCodeStatus
    type?: VoucherType
    /**
     * Number of used
     * @format int32
     */
    used?: number
    /**
     * Allowed number of uses
     * @format int32
     */
    usableCount?: number
    isDeleted?: boolean
    /** @format date-time */
    deletedAt?: string | null
    code?: string | null
}

export interface ReusableVoucherViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: ReusableVoucherViewModel
}

export interface SearchItemViewModel {
    id: string | null
    nameFa: string | null
    slug: string | null
    /** @format int32 */
    position?: number
    type?: SearchItemType
}

export interface SearchItemWithImageViewModel {
    id: string | null
    nameFa: string | null
    slug: string | null
    /** @format int32 */
    position?: number
    type?: SearchItemType
    imageUrl?: string | null
}

export interface SearchViewModel {
    queryId?: string | null
    products?: SearchItemWithImageViewModel[] | null
    categories?: SearchItemViewModel[] | null
    brands?: SearchItemViewModel[] | null
    popularSearch?: SearchItemViewModel[] | null
}

export interface SearchViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: SearchViewModel
}

export interface SetFlagRequest {
    flag?: AvailableToPurchaseFlag
}

export interface SetGoldPriceManuallyRequest {
    /** @format int64 */
    goldPrice?: number
    /** @format date-time */
    expiredAt?: string
}

export interface SetShippingConfigurationsRequest {
    /** @format int32 */
    freeShippingMinPrice?: number
    /** @format int32 */
    packagingCost?: number
}

export interface SetShippingConfigurationsViewModel {
    /** @format int32 */
    freeShippingMinPrice?: number
    /** @format int32 */
    packagingCost?: number
}

export interface SetShippingConfigurationsViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: SetShippingConfigurationsViewModel
}

export interface Setting {
    /** @format float */
    S?: number
    /** @format float */
    A?: number
    /** @format float */
    B?: number
    /** @format float */
    C?: number
    /** @format float */
    D?: number
    /** @format float */
    E?: number
}

export interface StatsAddToCartRequest {
    /** @format uuid */
    userToken: string
    docId: string | null
    queryId: string | null
}

export interface StockFacetViewModel {
    hasStock?: FacetValueViewModel
    outOfStock?: FacetValueViewModel
}

export interface StockOutDaysEffect {
    minimumDiscountFirst?: Discount
    minimumDiscountSecond?: Discount
    maximumDiscountFirst?: Discount
    maximumDiscountSecond?: Discount
}

export interface SubCartViewModel {
    id?: string | null
    items?: CartItemViewModel[] | null
    /** @format int64 */
    totalPrice?: number
    /** @format int64 */
    totalSalesPrice?: number
    /** @format int64 */
    totalCartDiscount?: number
    /** @format int64 */
    totalEffectivePrice?: number
    /** @format int64 */
    totalItemDiscount?: number
    /** @format int32 */
    itemCount?: number
    /** @format int32 */
    sumOfQty?: number
    changes?: CartItemChangedDataViewModel[] | null
    voucher?: CartVoucherViewModel
    promotion?: CartPromotionViewModel
    shipBySeller?: boolean
    vendorId?: VendorId
    vendorDisplayName?: string | null
    /** @format double */
    leadTimeInDay?: number
}

export interface SubOrderViewModel {
    id?: string | null
    deliveryTypeTitle?: string | null
    lineItems?: LineItemViewModel[] | null
}

export interface SubscribeNewsletterRequest {
    /**
     * @format email
     * @minLength 1
     */
    email: string
}

export interface SuccessEnvelop {
    isSuccess?: boolean
    data?: any
}

export interface SyncProductToSearchiaViewModel {
    /** @format int32 */
    touchedProductsCount?: number
    descriptions?: string | null
}

export interface SyncProductToSearchiaViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: SyncProductToSearchiaViewModel
}

export interface UniqueVoucherViewModel {
    /** @format int64 */
    id?: number
    title?: string | null
    /** @format date-time */
    from?: string
    /** @format date-time */
    to?: string
    status?: VoucherCodeStatus
    type?: VoucherType
    /**
     * Number of used
     * @format int32
     */
    used?: number
    /**
     * Allowed number of uses
     * @format int32
     */
    usableCount?: number
    isDeleted?: boolean
    /** @format date-time */
    deletedAt?: string | null
    /** @format int64 */
    lastGeneratedId?: number
}

export interface UniqueVoucherViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: UniqueVoucherViewModel
}

export interface UpdateGoldLotRequest {
    /** @format double */
    makingFeePercent?: number
    /** @format double */
    marginPercent?: number
    /** @format int64 */
    nonGoldComponentCost?: number
    enableVat?: boolean
    /** @format int32 */
    qty?: number
    /** @format double */
    discount?: number | null
}

export interface UpdateGoldLotResponse {
    /** @format int64 */
    amount?: number
    /** @format int64 */
    goldPrice?: number
    /** @format double */
    goldValue?: number
    /** @format double */
    makingFeePercent?: number
    /** @format double */
    marginPercent?: number
    /** @format int64 */
    nonGoldComponentCost?: number
    /** @format double */
    vatPercent?: number
    /** @format date-time */
    goldPriceExpiration?: string
    /** @format double */
    makingFee?: number
    /** @format double */
    margin?: number
    /** @format double */
    vat?: number
    /** @format int64 */
    salesPrice?: number | null
    /** @format double */
    discountPercent?: number | null
    /** @format int32 */
    qty?: number
}

export interface UpdateGoldLotResponseSuccessEnvelop {
    isSuccess?: boolean
    data?: UpdateGoldLotResponse
}

export interface UpdateLotQtyRequest {
    vendorAtpCode?: string | null
    /** @format int32 */
    qty?: number
    version?: string | null
}

export interface UpdateVendorDisplayNameRequest {
    vendorId?: string | null
    displayName?: string | null
}

export interface UpdateVendorLotRequestViewModel {
    /** @format int32 */
    atpId?: number
    lotId?: string | null
    /** @format int64 */
    salesPrice?: number
    /** @format int32 */
    qty?: number
}

export interface VcaAtpViewModel {
    /** @format int32 */
    id?: number
    variantNameFa?: string | null
}

export interface VcaListItemViewModel {
    /** @format uuid */
    id?: string
    atp?: VcaAtpViewModel
    vendor?: VcaVendorViewModel
    /** @format int64 */
    basePrice?: number
    /** @format double */
    commission?: number
}

export interface VcaListItemViewModelKibaPaginationViewModel {
    /** @format int32 */
    totalCount?: number
    /** @format int32 */
    pageNumber?: number
    /** @format int32 */
    pageSize?: number
    items?: VcaListItemViewModel[] | null
}

export interface VcaListItemViewModelKibaPaginationViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: VcaListItemViewModelKibaPaginationViewModel
}

export interface VcaVendorViewModel {
    id?: string | null
    name?: string | null
}

export interface VendorId {
    value?: string | null
}

export interface VendorItemViewModel {
    id?: string | null
    name?: string | null
    displayName?: string | null
}

export interface VendorItemViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: VendorItemViewModel
}

export interface VendorLotItemViewModel {
    /** @format int32 */
    atpId?: number
    lotId?: string | null
    productName?: string | null
    link?: string | null
    brand?: string | null
    weight?: ProductVariantWeight
    /** @format int32 */
    availableQty?: number
    /** @format int32 */
    reserveQty?: number
    /** @format int64 */
    basePrice?: number
    /** @format int64 */
    salesPrice?: number
    stockType?: StockType
    colorName?: string | null
    productImage?: string | null
    /** @format int64 */
    currentSalableSalesPrice?: number | null
    /** @format double */
    leadTime?: number
    variantNameEn?: string | null
    variantNameFa?: string | null
    isBuyBoxWinner?: boolean
    goldBasePrice?: GoldBasePrice
    /** @format double */
    discountPercent?: number | null
    vendorAtpCode?: string | null
    rowVer?: string | null
}

export interface VendorLotItemViewModelKibaPaginationViewModel {
    /** @format int32 */
    totalCount?: number
    /** @format int32 */
    pageNumber?: number
    /** @format int32 */
    pageSize?: number
    items?: VendorLotItemViewModel[] | null
}

export interface VendorLotItemViewModelKibaPaginationViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: VendorLotItemViewModelKibaPaginationViewModel
}

export interface VendorLotViewModel {
    vendorId?: string | null
    vendorName?: string | null
}

export interface VendorPaginationListByFilterViewModel {
    id?: string | null
    name?: string | null
    displayName?: string | null
}

export interface VendorPaginationListByFilterViewModelPagination {
    /** @format int32 */
    totalCount?: number
    /** @format int32 */
    pageNumber?: number
    /** @format int32 */
    pageSize?: number
    items?: VendorPaginationListByFilterViewModel[] | null
    hasItem?: boolean
    /** @format int32 */
    totalPagesCount?: number
}

export interface VendorPaginationListByFilterViewModelPaginationSuccessEnvelop {
    isSuccess?: boolean
    data?: VendorPaginationListByFilterViewModelPagination
}

export interface VendorSbsLotItemViewModel {
    /** @format int32 */
    atpId?: number
    lotId?: string | null
    productName?: string | null
    brand?: string | null
    weight?: ProductVariantWeight
    /** @format int32 */
    qty?: number
    /** @format int64 */
    basePrice?: number
    /** @format int64 */
    salesPrice?: number
    stockType?: StockType
    colorName?: string | null
    /** @format int64 */
    currentSalableSalesPrice?: number | null
    /** @format double */
    leadTime?: number
    variantNameEn?: string | null
    variantNameFa?: string | null
    isBuyBoxWinner?: boolean
    goldBasePrice?: GoldBasePrice
    /** @format double */
    discountPercent?: number | null
    vendorAtpCode?: string | null
    version?: string | null
}

export interface VendorSbsLotItemViewModelKibaPaginationViewModel {
    /** @format int32 */
    totalCount?: number
    /** @format int32 */
    pageNumber?: number
    /** @format int32 */
    pageSize?: number
    items?: VendorSbsLotItemViewModel[] | null
}

export interface VendorSbsLotItemViewModelKibaPaginationViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: VendorSbsLotItemViewModelKibaPaginationViewModel
}

export interface VendorSbsLotItemViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: VendorSbsLotItemViewModel
}

export interface VendorSearchItemViewModel {
    id: string | null
    nameFa: string | null
    slug: string | null
    /** @format int32 */
    position?: number
    type?: SearchItemType
}

export interface VendorSearchItemWithImageViewModel {
    id: string | null
    nameFa: string | null
    slug: string | null
    /** @format int32 */
    position?: number
    type?: SearchItemType
    imageUrl?: string | null
}

export interface VendorSearchViewModel {
    queryId?: string | null
    products?: VendorSearchItemWithImageViewModel[] | null
    categories?: VendorSearchItemViewModel[] | null
    brands?: VendorSearchItemViewModel[] | null
    popularSearch?: VendorSearchItemViewModel[] | null
}

export interface VendorSearchViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: VendorSearchViewModel
}

export interface VoucherDtoViewModel {
    /** @format int64 */
    id?: number
    title?: string | null
    /** @format date-time */
    from?: string
    /** @format date-time */
    to?: string
    status?: VoucherCodeStatus
    type?: VoucherType
    /**
     * Number of used
     * @format int32
     */
    used?: number
    /**
     * Allowed number of uses
     * @format int32
     */
    usableCount?: number
    /** @format int32 */
    availableCount?: number
    code?: string | null
    /** @format int64 */
    lastGeneratedId?: number | null
}

export interface VoucherDtoViewModelKibaPaginationViewModel {
    /** @format int32 */
    totalCount?: number
    /** @format int32 */
    pageNumber?: number
    /** @format int32 */
    pageSize?: number
    items?: VoucherDtoViewModel[] | null
}

export interface VoucherDtoViewModelKibaPaginationViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: VoucherDtoViewModelKibaPaginationViewModel
}

export interface VoucherId {
    /** @format int64 */
    value?: number
}

export type QueryParamsType = Record<string | number, any>
export type ResponseFormat = keyof Omit<Body, 'body' | 'bodyUsed'>

export interface FullRequestParams extends Omit<RequestInit, 'body'> {
    /** set parameter to `true` for call `securityWorker` for this request */
    secure?: boolean
    /** request path */
    path: string
    /** content type of request body */
    type?: ContentType
    /** query params */
    query?: QueryParamsType
    /** format of response (i.e. response.json() -> format: "json") */
    format?: ResponseFormat
    /** request body */
    body?: unknown
    /** base url */
    baseUrl?: string
    /** request cancellation token */
    cancelToken?: CancelToken
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>

export interface ApiConfig<SecurityDataType = unknown> {
    baseUrl?: string
    baseApiParams?: Omit<RequestParams, 'baseUrl' | 'cancelToken' | 'signal'>
    securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void
    customFetch?: typeof fetch
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
    data: D
    error: E
}

type CancelToken = Symbol | string | number

export enum ContentType {
    Json = 'application/json',
    JsonApi = 'application/vnd.api+json',
    FormData = 'multipart/form-data',
    UrlEncoded = 'application/x-www-form-urlencoded',
    Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
    public baseUrl: string = ''
    private securityData: SecurityDataType | null = null
    private securityWorker?: ApiConfig<SecurityDataType>['securityWorker']
    private abortControllers = new Map<CancelToken, AbortController>()
    private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams)

    private baseApiParams: RequestParams = {
        credentials: 'same-origin',
        headers: {},
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
    }

    constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
        Object.assign(this, apiConfig)
    }

    public setSecurityData = (data: SecurityDataType | null) => {
        this.securityData = data
    }

    protected encodeQueryParam(key: string, value: any) {
        const encodedKey = encodeURIComponent(key)
        return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`
    }

    protected addQueryParam(query: QueryParamsType, key: string) {
        return this.encodeQueryParam(key, query[key])
    }

    protected addArrayQueryParam(query: QueryParamsType, key: string) {
        const value = query[key]
        return value.map((v: any) => this.encodeQueryParam(key, v)).join('&')
    }

    protected toQueryString(rawQuery?: QueryParamsType): string {
        const query = rawQuery || {}
        const keys = Object.keys(query).filter((key) => 'undefined' !== typeof query[key])
        return keys
            .map((key) =>
                Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)
            )
            .join('&')
    }

    protected addQueryParams(rawQuery?: QueryParamsType): string {
        const queryString = this.toQueryString(rawQuery)
        return queryString ? `?${queryString}` : ''
    }

    private contentFormatters: Record<ContentType, (input: any) => any> = {
        [ContentType.Json]: (input: any) =>
            input !== null && (typeof input === 'object' || typeof input === 'string') ? JSON.stringify(input) : input,
        [ContentType.JsonApi]: (input: any) =>
            input !== null && (typeof input === 'object' || typeof input === 'string') ? JSON.stringify(input) : input,
        [ContentType.Text]: (input: any) =>
            input !== null && typeof input !== 'string' ? JSON.stringify(input) : input,
        [ContentType.FormData]: (input: any) => {
            if (input instanceof FormData) {
                return input
            }

            return Object.keys(input || {}).reduce((formData, key) => {
                const property = input[key]
                formData.append(
                    key,
                    property instanceof Blob
                        ? property
                        : typeof property === 'object' && property !== null
                          ? JSON.stringify(property)
                          : `${property}`
                )
                return formData
            }, new FormData())
        },
        [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
    }

    protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
        return {
            ...this.baseApiParams,
            ...params1,
            ...(params2 || {}),
            headers: {
                ...(this.baseApiParams.headers || {}),
                ...(params1.headers || {}),
                ...((params2 && params2.headers) || {}),
            },
        }
    }

    protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
        if (this.abortControllers.has(cancelToken)) {
            const abortController = this.abortControllers.get(cancelToken)
            if (abortController) {
                return abortController.signal
            }
            return void 0
        }

        const abortController = new AbortController()
        this.abortControllers.set(cancelToken, abortController)
        return abortController.signal
    }

    public abortRequest = (cancelToken: CancelToken) => {
        const abortController = this.abortControllers.get(cancelToken)

        if (abortController) {
            abortController.abort()
            this.abortControllers.delete(cancelToken)
        }
    }

    public request = async <T = any, E = any>({
        body,
        secure,
        path,
        type,
        query,
        format,
        baseUrl,
        cancelToken,
        ...params
    }: FullRequestParams): Promise<HttpResponse<T, E>> => {
        const secureParams =
            ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) &&
                this.securityWorker &&
                (await this.securityWorker(this.securityData))) ||
            {}
        const requestParams = this.mergeRequestParams(params, secureParams)
        const queryString = query && this.toQueryString(query)
        const payloadFormatter = this.contentFormatters[type || ContentType.Json]
        const responseFormat = format || requestParams.format

        return this.customFetch(`${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`, {
            ...requestParams,
            headers: {
                ...(requestParams.headers || {}),
                ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
            },
            signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null,
            body: typeof body === 'undefined' || body === null ? null : payloadFormatter(body),
        }).then(async (response) => {
            const r = response as HttpResponse<T, E>
            r.data = null as unknown as T
            r.error = null as unknown as E

            const data = !responseFormat
                ? r
                : await response[responseFormat]()
                      .then((data) => {
                          if (r.ok) {
                              r.data = data
                          } else {
                              r.error = data
                          }
                          return r
                      })
                      .catch((e) => {
                          r.error = e
                          return r
                      })

            if (cancelToken) {
                this.abortControllers.delete(cancelToken)
            }

            if (!response.ok) throw data
            return data
        })
    }
}

/**
 * @title Nautilus
 * @version v1
 *
 * Nautilus back-end (Web API)
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
    internal = {
        /**
         * No description
         *
         * @tags Maintenance
         * @name ApiNtlV1772D1246C613453E92A1E3D826075550UpdateBasePriceList
         * @request GET:/__internal/api/ntl/v1/772D1246C613453E92A1E3D826075550/update-basePrice
         */
        apiNtlV1772D1246C613453E92A1E3D826075550UpdateBasePriceList: (
            query?: {
                /** @format int32 */
                pageSize?: number
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/__internal/api/ntl/v1/772D1246C613453E92A1E3D826075550/update-basePrice`,
                method: 'GET',
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags AvailableToPurchase
         * @name ApiNtlV1CatalogAtpIdItemProposalList
         * @request GET:/__internal/api/ntl/v1/catalog/atp/id/{id}/item-proposal
         */
        apiNtlV1CatalogAtpIdItemProposalList: (id: string, params: RequestParams = {}) =>
            this.request<ItemProposalViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/__internal/api/ntl/v1/catalog/atp/id/${id}/item-proposal`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags GrainState
         * @name ApiNtlV1GrainsStatesList
         * @request GET:/__internal/api/ntl/v1/grains/{type}/{id}/states
         */
        apiNtlV1GrainsStatesList: (type: string, id: string, params: RequestParams = {}) =>
            this.request<string, any>({
                path: `/__internal/api/ntl/v1/grains/${type}/${id}/states`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Fallback
         * @name ApiNtlV1GrainsFallbackAtpCreate
         * @request POST:/__internal/api/ntl/v1/grains/fallback/atp
         */
        apiNtlV1GrainsFallbackAtpCreate: (
            query?: {
                /** @format int32 */
                id?: number
                syncType?: SyncType
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/__internal/api/ntl/v1/grains/fallback/atp`,
                method: 'POST',
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Fallback
         * @name ApiNtlV1GrainsFallbackCartCreate
         * @request POST:/__internal/api/ntl/v1/grains/fallback/cart
         */
        apiNtlV1GrainsFallbackCartCreate: (
            query?: {
                /** @format uuid */
                id?: string
                syncType?: SyncType
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/__internal/api/ntl/v1/grains/fallback/cart`,
                method: 'POST',
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags AvailableToPurchase
         * @name CatalogAtpAuditReserveCreate
         * @request POST:/__internal/catalog/atp/audit-reserve
         */
        catalogAtpAuditReserveCreate: (
            data: {
                /** @format binary */
                file?: File
                /** @default true */
                dry_mode?: boolean
            },
            params: RequestParams = {}
        ) =>
            this.request<any, FailureEnvelop>({
                path: `/__internal/catalog/atp/audit-reserve`,
                method: 'POST',
                body: data,
                type: ContentType.FormData,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Debug
         * @name DebugBinobanSyncAtpCreate
         * @request POST:/__internal/debug/binoban/sync-atp
         */
        debugBinobanSyncAtpCreate: (
            query?: {
                /** @format int32 */
                productId?: number
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/__internal/debug/binoban/sync-atp`,
                method: 'POST',
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Debug
         * @name DebugBinobanSyncProductCreate
         * @request POST:/__internal/debug/binoban/sync-product
         */
        debugBinobanSyncProductCreate: (
            query?: {
                /** @format int32 */
                productId?: number
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/__internal/debug/binoban/sync-product`,
                method: 'POST',
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Debug
         * @name DebugBinobanSyncVendorCreate
         * @request POST:/__internal/debug/binoban/sync-vendor
         */
        debugBinobanSyncVendorCreate: (
            query?: {
                vendorId?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/__internal/debug/binoban/sync-vendor`,
                method: 'POST',
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Debug
         * @name DebugElasticsearchList
         * @request GET:/__internal/debug/elasticsearch
         */
        debugElasticsearchList: (
            query?: {
                /**
                 * @format int32
                 * @default 1
                 */
                page_number?: number
                /**
                 * @format int32
                 * @min 1
                 * @max 300
                 * @default 10
                 */
                page_size?: number
                /** @default "" */
                query?: string
                has_stock?: boolean
                sort?: ProductListSort
                brand?: string[]
                color?: string[]
                cat?: string[]
                facet?: string[]
                /** @format int32 */
                from_price?: number
                /** @format int32 */
                to_price?: number
                brand_id?: string
                cat_id?: string
                tag_id?: string
                id?: string[]
                count_only?: boolean
                analytics_tag?: AnalyticsTagType
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/__internal/debug/elasticsearch`,
                method: 'GET',
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Debug
         * @name DebugGoldPriceList
         * @request GET:/__internal/debug/gold-price
         */
        debugGoldPriceList: (params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/__internal/debug/gold-price`,
                method: 'GET',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Debug
         * @name DebugKibaHttpClientHandlersList
         * @request GET:/__internal/debug/kiba/http-client-handlers
         */
        debugKibaHttpClientHandlersList: (params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/__internal/debug/kiba/http-client-handlers`,
                method: 'GET',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Debug
         * @name DebugKibaWorkersList
         * @request GET:/__internal/debug/kiba/workers
         */
        debugKibaWorkersList: (
            query?: {
                name?: string
                is_enabled?: boolean
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/__internal/debug/kiba/workers`,
                method: 'GET',
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Debug
         * @name DebugMonitoringOrdersUnprocessDraftOrderCountList
         * @request GET:/__internal/debug/monitoring/orders/unprocess-draft-order-count
         */
        debugMonitoringOrdersUnprocessDraftOrderCountList: (params: RequestParams = {}) =>
            this.request<number, any>({
                path: `/__internal/debug/monitoring/orders/unprocess-draft-order-count`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Debug
         * @name DebugOrdersOptionsList
         * @request GET:/__internal/debug/orders/options
         */
        debugOrdersOptionsList: (params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/__internal/debug/orders/options`,
                method: 'GET',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Debug
         * @name DebugProductsRefreshStateList
         * @request GET:/__internal/debug/products/{id}/refresh-state
         */
        debugProductsRefreshStateList: (id: number, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/__internal/debug/products/${id}/refresh-state`,
                method: 'GET',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Debug
         * @name DebugProductsProductGrainOptionsList
         * @request GET:/__internal/debug/products/product-grain-options
         */
        debugProductsProductGrainOptionsList: (params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/__internal/debug/products/product-grain-options`,
                method: 'GET',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Debug
         * @name DebugRabbitMqAtpChangeEventCreate
         * @request POST:/__internal/debug/rabbit-mq/atp-change-event
         */
        debugRabbitMqAtpChangeEventCreate: (data: AtpChangeEvent, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/__internal/debug/rabbit-mq/atp-change-event`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Debug
         * @name DebugRabbitMqAtpChangeItemProposalEventCreate
         * @request POST:/__internal/debug/rabbit-mq/atp-change-item-proposal-event
         */
        debugRabbitMqAtpChangeItemProposalEventCreate: (data: AtpChangeItemProposalEvent, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/__internal/debug/rabbit-mq/atp-change-item-proposal-event`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Debug
         * @name DebugRabbitMqProductChangeEventCreate
         * @request POST:/__internal/debug/rabbit-mq/product-change-event
         */
        debugRabbitMqProductChangeEventCreate: (data: ProductChangeEvent, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/__internal/debug/rabbit-mq/product-change-event`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Debug
         * @name DebugSearchiaOptionsList
         * @request GET:/__internal/debug/searchia/options
         */
        debugSearchiaOptionsList: (params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/__internal/debug/searchia/options`,
                method: 'GET',
                ...params,
            }),
    }
    api = {
        /**
         * No description
         *
         * @tags Vendor
         * @name Ntl3rdVndV1AtpLotList
         * @request GET:/api/ntl/3rd/vnd/v1/atp/{vendor_atp_code}/lot
         */
        ntl3rdVndV1AtpLotList: (vendorAtpCode: string, params: RequestParams = {}) =>
            this.request<VendorSbsLotItemViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/3rd/vnd/v1/atp/${vendorAtpCode}/lot`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Vendor
         * @name Ntl3rdVndV1LotQtyCreate
         * @request POST:/api/ntl/3rd/vnd/v1/lot/qty
         */
        ntl3rdVndV1LotQtyCreate: (data: UpdateLotQtyRequest, params: RequestParams = {}) =>
            this.request<UpdateGoldLotResponseSuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/3rd/vnd/v1/lot/qty`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Vendor
         * @name Ntl3rdVndV1LotsList
         * @request GET:/api/ntl/3rd/vnd/v1/lots
         */
        ntl3rdVndV1LotsList: (
            query?: {
                /**
                 * @format int32
                 * @default 1
                 */
                page_number?: number
                /**
                 * @format int32
                 * @min 1
                 * @max 2000
                 * @default 2000
                 */
                page_size?: number
            },
            params: RequestParams = {}
        ) =>
            this.request<VendorSbsLotItemViewModelKibaPaginationViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/3rd/vnd/v1/lots`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags BatchImport
         * @name NtlAdminV1BatchImportCommercialPricingRuleCreate
         * @summary Import commercial pricing rule(s) using excel file
         * @request POST:/api/ntl/admin/v1/batch-import/commercial-pricing-rule
         */
        ntlAdminV1BatchImportCommercialPricingRuleCreate: (
            data: {
                /** @format binary */
                file?: File
                /** @default true */
                include_first_row?: boolean
            },
            params: RequestParams = {}
        ) =>
            this.request<File, FailureEnvelop>({
                path: `/api/ntl/admin/v1/batch-import/commercial-pricing-rule`,
                method: 'POST',
                body: data,
                type: ContentType.FormData,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags BatchImport
         * @name NtlAdminV1BatchImportCommercialPricingRuleDownloadResultList
         * @summary Download batch import commercial pricing rule list result
         * @request GET:/api/ntl/admin/v1/batch-import/commercial-pricing-rule-download-result
         */
        ntlAdminV1BatchImportCommercialPricingRuleDownloadResultList: (
            query?: {
                /** @format int32 */
                id?: number
            },
            params: RequestParams = {}
        ) =>
            this.request<FileStreamResultSuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/admin/v1/batch-import/commercial-pricing-rule-download-result`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags BatchImport
         * @name NtlAdminV1BatchImportCommercialPricingRuleListList
         * @summary Get batch import commercial pricing rule list
         * @request GET:/api/ntl/admin/v1/batch-import/commercial-pricing-rule-list
         */
        ntlAdminV1BatchImportCommercialPricingRuleListList: (
            query?: {
                /**
                 * @format int32
                 * @default 1
                 */
                page_number?: number
                /**
                 * @format int32
                 * @min 1
                 * @max 300
                 * @default 10
                 */
                page_size?: number
            },
            params: RequestParams = {}
        ) =>
            this.request<BatchImportPricingRuleListItemViewModelKibaPaginationViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/admin/v1/batch-import/commercial-pricing-rule-list`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags BatchImport
         * @name NtlAdminV1BatchImportCommercialPricingRuleSampleFileList
         * @summary Download batch import commercial pricing rule sample file
         * @request GET:/api/ntl/admin/v1/batch-import/commercial-pricing-rule-sample-file
         */
        ntlAdminV1BatchImportCommercialPricingRuleSampleFileList: (params: RequestParams = {}) =>
            this.request<FileStreamResultSuccessEnvelop, void>({
                path: `/api/ntl/admin/v1/batch-import/commercial-pricing-rule-sample-file`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AvailableToPurchase
         * @name NtlAdminV1CatalogAtpList
         * @request GET:/api/ntl/admin/v1/catalog/atp
         */
        ntlAdminV1CatalogAtpList: (
            query?: {
                /**
                 * @format int32
                 * @default 1
                 */
                page_number?: number
                /**
                 * @format int32
                 * @default 10
                 */
                page_size?: number
                /** @format int32 */
                atp_id?: number
                /** @format int32 */
                product_id?: number
                /** @format int32 */
                tag_id?: number
                /** @format int32 */
                brand_id?: number
                /** @format int32 */
                category_id?: number
                lot_status?: LotStatus
                pricing_rule_status?: PricingRuleStatus
            },
            params: RequestParams = {}
        ) =>
            this.request<AvailableToPurchaseEntityViewModelKibaPaginationViewModelSuccessEnvelop, any>({
                path: `/api/ntl/admin/v1/catalog/atp`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AvailableToPurchase
         * @name NtlAdminV1CatalogAtpExcelList
         * @request GET:/api/ntl/admin/v1/catalog/atp/_excel
         */
        ntlAdminV1CatalogAtpExcelList: (
            query?: {
                /** @format int32 */
                atp_id?: number
                lot_status?: LotStatus
                pricing_rule_status?: PricingRuleStatus
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/api/ntl/admin/v1/catalog/atp/_excel`,
                method: 'GET',
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags UnsalableQty
         * @name NtlAdminV1CatalogAtpUnsalableQtyCreate
         * @summary Add unsalable qty
         * @request POST:/api/ntl/admin/v1/catalog/atp/{atpId}/{lotId}/unsalable-qty
         */
        ntlAdminV1CatalogAtpUnsalableQtyCreate: (
            atpId: number,
            lotId: string,
            data: AddAtpUnsalableQtyViewModel,
            params: RequestParams = {}
        ) =>
            this.request<FailureEnvelop, any>({
                path: `/api/ntl/admin/v1/catalog/atp/${atpId}/${lotId}/unsalable-qty`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AvailableToPurchase
         * @name NtlAdminV1CatalogAtpFlagsCreate
         * @request POST:/api/ntl/admin/v1/catalog/atp/{atpId}/flags
         */
        ntlAdminV1CatalogAtpFlagsCreate: (atpId: number, data: SetFlagRequest, params: RequestParams = {}) =>
            this.request<SuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/admin/v1/catalog/atp/${atpId}/flags`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AvailableToPurchase
         * @name NtlAdminV1CatalogAtpFlagsDelete
         * @request DELETE:/api/ntl/admin/v1/catalog/atp/{id}/flags
         */
        ntlAdminV1CatalogAtpFlagsDelete: (
            id: number,
            query: {
                flag: AvailableToPurchaseFlag
            },
            params: RequestParams = {}
        ) =>
            this.request<void, FailureEnvelop>({
                path: `/api/ntl/admin/v1/catalog/atp/${id}/flags`,
                method: 'DELETE',
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags AvailableToPurchase
         * @name NtlAdminV1CatalogAtpBatchRevieveUnsalableQtyCreate
         * @request POST:/api/ntl/admin/v1/catalog/atp/batch-revieve-unsalable-qty
         */
        ntlAdminV1CatalogAtpBatchRevieveUnsalableQtyCreate: (
            data: {
                /** @format binary */
                file?: File
            },
            query?: {
                reference?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/api/ntl/admin/v1/catalog/atp/batch-revieve-unsalable-qty`,
                method: 'POST',
                query: query,
                body: data,
                type: ContentType.FormData,
                ...params,
            }),

        /**
         * No description
         *
         * @tags AvailableToPurchase
         * @name NtlAdminV1CatalogAtpBatchRevieveUnsalableQtySampleFileList
         * @request GET:/api/ntl/admin/v1/catalog/atp/batch-revieve-unsalable-qty-sample-file
         */
        ntlAdminV1CatalogAtpBatchRevieveUnsalableQtySampleFileList: (params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/ntl/admin/v1/catalog/atp/batch-revieve-unsalable-qty-sample-file`,
                method: 'GET',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AvailableToPurchase
         * @name NtlAdminV1CatalogAtpCleanupStaleDataCreate
         * @summary Cleanup stale data
         * @request POST:/api/ntl/admin/v1/catalog/atp/cleanup-stale-data
         */
        ntlAdminV1CatalogAtpCleanupStaleDataCreate: (
            data: {
                /** @format binary */
                file?: File
                /** @default true */
                include_first_row?: boolean
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/api/ntl/admin/v1/catalog/atp/cleanup-stale-data`,
                method: 'POST',
                body: data,
                type: ContentType.FormData,
                ...params,
            }),

        /**
         * No description
         *
         * @tags AvailableToPurchase
         * @name NtlAdminV1CatalogAtpCleanupStaleDataSampleFileList
         * @summary Download Cleanup stale data sample file
         * @request GET:/api/ntl/admin/v1/catalog/atp/cleanup-stale-data/sample-file
         */
        ntlAdminV1CatalogAtpCleanupStaleDataSampleFileList: (params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/ntl/admin/v1/catalog/atp/cleanup-stale-data/sample-file`,
                method: 'GET',
                ...params,
            }),

        /**
         * No description
         *
         * @tags DefaultDiscountRule
         * @name NtlAdminV1CatalogAtpDefaultDiscountRulesList
         * @request GET:/api/ntl/admin/v1/catalog/atp/default-discount-rules
         */
        ntlAdminV1CatalogAtpDefaultDiscountRulesList: (
            query?: {
                /**
                 * @format int32
                 * @default 1
                 */
                page_number?: number
                /**
                 * @format int32
                 * @default 10
                 */
                page_size?: number
                /** @format int32 */
                atp_id?: number
                /** @format int32 */
                product_id?: number
                exist?: boolean
            },
            params: RequestParams = {}
        ) =>
            this.request<GetDefaultDefaultDiscountRuleViewModelKibaPaginationViewModelSuccessEnvelop, any>({
                path: `/api/ntl/admin/v1/catalog/atp/default-discount-rules`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags DefaultDiscountRule
         * @name NtlAdminV1CatalogAtpDefaultDiscountRulesExcelList
         * @request GET:/api/ntl/admin/v1/catalog/atp/default-discount-rules/_excel
         */
        ntlAdminV1CatalogAtpDefaultDiscountRulesExcelList: (
            query?: {
                /** @format int32 */
                atp_id?: number
                /** @format int32 */
                product_id?: number
                exist?: boolean
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/api/ntl/admin/v1/catalog/atp/default-discount-rules/_excel`,
                method: 'GET',
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags DefaultDiscountRule
         * @name NtlAdminV1CatalogAtpDefaultDiscountRulesBatchImportProcessCreate
         * @request POST:/api/ntl/admin/v1/catalog/atp/default-discount-rules/batch-import-process
         */
        ntlAdminV1CatalogAtpDefaultDiscountRulesBatchImportProcessCreate: (
            data: {
                /** @format binary */
                file?: File
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/api/ntl/admin/v1/catalog/atp/default-discount-rules/batch-import-process`,
                method: 'POST',
                body: data,
                type: ContentType.FormData,
                ...params,
            }),

        /**
         * No description
         *
         * @tags DefaultDiscountRule
         * @name NtlAdminV1CatalogAtpDefaultDiscountRulesBatchImportProcessSampleFileList
         * @request GET:/api/ntl/admin/v1/catalog/atp/default-discount-rules/batch-import-process-sample-file
         */
        ntlAdminV1CatalogAtpDefaultDiscountRulesBatchImportProcessSampleFileList: (params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/ntl/admin/v1/catalog/atp/default-discount-rules/batch-import-process-sample-file`,
                method: 'GET',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AvailableToPurchase
         * @name NtlAdminV1CatalogAtpDumpingPricingRuleImportProcessCreate
         * @summary Create a dumping pricing rule import process using excel file
         * @request POST:/api/ntl/admin/v1/catalog/atp/dumping-pricing-rule-import-process
         */
        ntlAdminV1CatalogAtpDumpingPricingRuleImportProcessCreate: (
            data: {
                /** @format binary */
                file?: File
                /** @default true */
                include_first_row?: boolean
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/api/ntl/admin/v1/catalog/atp/dumping-pricing-rule-import-process`,
                method: 'POST',
                body: data,
                type: ContentType.FormData,
                ...params,
            }),

        /**
         * No description
         *
         * @tags AvailableToPurchase
         * @name NtlAdminV1CatalogAtpDumpingPricingRuleImportSampleFileList
         * @summary Download dumping pricing rule import sample file
         * @request GET:/api/ntl/admin/v1/catalog/atp/dumping-pricing-rule-import-sample-file
         */
        ntlAdminV1CatalogAtpDumpingPricingRuleImportSampleFileList: (params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/ntl/admin/v1/catalog/atp/dumping-pricing-rule-import-sample-file`,
                method: 'GET',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AvailableToPurchase
         * @name NtlAdminV1CatalogAtpDumpingPricingRuleRemoveProcessCreate
         * @summary Remove a dumping pricing rule using excel file
         * @request POST:/api/ntl/admin/v1/catalog/atp/dumping-pricing-rule-remove-process
         */
        ntlAdminV1CatalogAtpDumpingPricingRuleRemoveProcessCreate: (
            data: {
                /** @format binary */
                file?: File
                /** @default true */
                include_first_row?: boolean
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/api/ntl/admin/v1/catalog/atp/dumping-pricing-rule-remove-process`,
                method: 'POST',
                body: data,
                type: ContentType.FormData,
                ...params,
            }),

        /**
         * No description
         *
         * @tags AvailableToPurchase
         * @name NtlAdminV1CatalogAtpDumpingPricingRuleRemoveSampleFileList
         * @summary Download dumping pricing rule remove sample file
         * @request GET:/api/ntl/admin/v1/catalog/atp/dumping-pricing-rule-remove-sample-file
         */
        ntlAdminV1CatalogAtpDumpingPricingRuleRemoveSampleFileList: (params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/ntl/admin/v1/catalog/atp/dumping-pricing-rule-remove-sample-file`,
                method: 'GET',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AvailableToPurchase
         * @name NtlAdminV1CatalogAtpFlagsList
         * @request GET:/api/ntl/admin/v1/catalog/atp/flags
         */
        ntlAdminV1CatalogAtpFlagsList: (
            query?: {
                /**
                 * @format int32
                 * @default 1
                 */
                page_number?: number
                /**
                 * @format int32
                 * @min 1
                 * @max 300
                 * @default 10
                 */
                page_size?: number
                flags?: string
                /** @format int32 */
                atp_id?: number
                /** @format int32 */
                product_id?: number
            },
            params: RequestParams = {}
        ) =>
            this.request<AtpListItemByFlagViewModelKibaPaginationViewModelSuccessEnvelop, any>({
                path: `/api/ntl/admin/v1/catalog/atp/flags`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AvailableToPurchase
         * @name NtlAdminV1CatalogAtpFlagsExcelList
         * @request GET:/api/ntl/admin/v1/catalog/atp/flags/_excel
         */
        ntlAdminV1CatalogAtpFlagsExcelList: (
            query?: {
                flags?: string
                /** @format int32 */
                atp_id?: number
                /** @format int32 */
                product_id?: number
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/api/ntl/admin/v1/catalog/atp/flags/_excel`,
                method: 'GET',
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags AvailableToPurchase
         * @name NtlAdminV1CatalogAtpFlagsGoldDelete
         * @summary Remove flag gold to available to purchase using excel file
         * @request DELETE:/api/ntl/admin/v1/catalog/atp/flags/gold
         */
        ntlAdminV1CatalogAtpFlagsGoldDelete: (
            data: {
                /** @format binary */
                file?: File
                /** @default true */
                include_first_row?: boolean
            },
            params: RequestParams = {}
        ) =>
            this.request<SuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/admin/v1/catalog/atp/flags/gold`,
                method: 'DELETE',
                body: data,
                type: ContentType.FormData,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AvailableToPurchase
         * @name NtlAdminV1CatalogAtpFlagsGoldCreate
         * @summary Import flag gold to available to purchase using excel file
         * @request POST:/api/ntl/admin/v1/catalog/atp/flags/gold
         */
        ntlAdminV1CatalogAtpFlagsGoldCreate: (
            data: {
                /** @format binary */
                file?: File
                /** @default true */
                include_first_row?: boolean
            },
            params: RequestParams = {}
        ) =>
            this.request<SuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/admin/v1/catalog/atp/flags/gold`,
                method: 'POST',
                body: data,
                type: ContentType.FormData,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AvailableToPurchase
         * @name NtlAdminV1CatalogAtpFlagsLegallyRestrictedDelete
         * @summary Remove flag legally restricted to available to purchase using excel file
         * @request DELETE:/api/ntl/admin/v1/catalog/atp/flags/legally-restricted
         */
        ntlAdminV1CatalogAtpFlagsLegallyRestrictedDelete: (
            data: {
                /** @format binary */
                file?: File
                /** @default true */
                include_first_row?: boolean
            },
            params: RequestParams = {}
        ) =>
            this.request<SuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/admin/v1/catalog/atp/flags/legally-restricted`,
                method: 'DELETE',
                body: data,
                type: ContentType.FormData,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AvailableToPurchase
         * @name NtlAdminV1CatalogAtpFlagsLegallyRestrictedCreate
         * @summary Import flag legally restricted to available to purchase using excel file
         * @request POST:/api/ntl/admin/v1/catalog/atp/flags/legally-restricted
         */
        ntlAdminV1CatalogAtpFlagsLegallyRestrictedCreate: (
            data: {
                /** @format binary */
                file?: File
                /** @default true */
                include_first_row?: boolean
            },
            params: RequestParams = {}
        ) =>
            this.request<SuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/admin/v1/catalog/atp/flags/legally-restricted`,
                method: 'POST',
                body: data,
                type: ContentType.FormData,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AvailableToPurchase
         * @name NtlAdminV1CatalogAtpFlagsPharmacyDelete
         * @summary Remove flag pharmacy to available to purchase using excel file
         * @request DELETE:/api/ntl/admin/v1/catalog/atp/flags/pharmacy
         */
        ntlAdminV1CatalogAtpFlagsPharmacyDelete: (
            data: {
                /** @format binary */
                file?: File
                /** @default true */
                include_first_row?: boolean
            },
            params: RequestParams = {}
        ) =>
            this.request<SuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/admin/v1/catalog/atp/flags/pharmacy`,
                method: 'DELETE',
                body: data,
                type: ContentType.FormData,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AvailableToPurchase
         * @name NtlAdminV1CatalogAtpFlagsPharmacyCreate
         * @summary Import flag pharmacy to available to purchase using excel file
         * @request POST:/api/ntl/admin/v1/catalog/atp/flags/pharmacy
         */
        ntlAdminV1CatalogAtpFlagsPharmacyCreate: (
            data: {
                /** @format binary */
                file?: File
                /** @default true */
                include_first_row?: boolean
            },
            params: RequestParams = {}
        ) =>
            this.request<SuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/admin/v1/catalog/atp/flags/pharmacy`,
                method: 'POST',
                body: data,
                type: ContentType.FormData,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AvailableToPurchase
         * @name NtlAdminV1CatalogAtpFlagsPromotionExcludedDelete
         * @summary Remove flag Promotion Excluded to available to purchase using excel file
         * @request DELETE:/api/ntl/admin/v1/catalog/atp/flags/promotion-excluded
         */
        ntlAdminV1CatalogAtpFlagsPromotionExcludedDelete: (
            data: {
                /** @format binary */
                file?: File
                /** @default true */
                include_first_row?: boolean
            },
            params: RequestParams = {}
        ) =>
            this.request<SuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/admin/v1/catalog/atp/flags/promotion-excluded`,
                method: 'DELETE',
                body: data,
                type: ContentType.FormData,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AvailableToPurchase
         * @name NtlAdminV1CatalogAtpFlagsPromotionExcludedCreate
         * @summary Import flag Promotion Excluded to available to purchase using excel file
         * @request POST:/api/ntl/admin/v1/catalog/atp/flags/promotion-excluded
         */
        ntlAdminV1CatalogAtpFlagsPromotionExcludedCreate: (
            data: {
                /** @format binary */
                file?: File
                /** @default true */
                include_first_row?: boolean
            },
            params: RequestParams = {}
        ) =>
            this.request<SuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/admin/v1/catalog/atp/flags/promotion-excluded`,
                method: 'POST',
                body: data,
                type: ContentType.FormData,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AvailableToPurchase
         * @name NtlAdminV1CatalogAtpFlagsSampleFileList
         * @summary Download import flag available to purchase sample file
         * @request GET:/api/ntl/admin/v1/catalog/atp/flags/sample-file
         */
        ntlAdminV1CatalogAtpFlagsSampleFileList: (params: RequestParams = {}) =>
            this.request<SuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/admin/v1/catalog/atp/flags/sample-file`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AvailableToPurchase
         * @name NtlAdminV1CatalogAtpPricingRuleImportProcessCreate
         * @summary Create a pricing rule import process using excel file
         * @request POST:/api/ntl/admin/v1/catalog/atp/pricing-rule-import-process
         */
        ntlAdminV1CatalogAtpPricingRuleImportProcessCreate: (
            data: {
                /** @format binary */
                file?: File
                /** @default true */
                include_first_row?: boolean
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/api/ntl/admin/v1/catalog/atp/pricing-rule-import-process`,
                method: 'POST',
                body: data,
                type: ContentType.FormData,
                ...params,
            }),

        /**
         * No description
         *
         * @tags AvailableToPurchase
         * @name NtlAdminV1CatalogAtpPricingRuleImportSampleFileList
         * @summary Download pricing rule import sample file
         * @request GET:/api/ntl/admin/v1/catalog/atp/pricing-rule-import-sample-file
         */
        ntlAdminV1CatalogAtpPricingRuleImportSampleFileList: (params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/ntl/admin/v1/catalog/atp/pricing-rule-import-sample-file`,
                method: 'GET',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AvailableToPurchase
         * @name NtlAdminV1CatalogAtpRegisterReminderCreate
         * @request POST:/api/ntl/admin/v1/catalog/atp/register-reminder
         */
        ntlAdminV1CatalogAtpRegisterReminderCreate: (
            data: {
                /** @format binary */
                file?: File
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/api/ntl/admin/v1/catalog/atp/register-reminder`,
                method: 'POST',
                body: data,
                type: ContentType.FormData,
                ...params,
            }),

        /**
         * No description
         *
         * @tags AvailableToPurchase
         * @name NtlAdminV1CatalogAtpRegisterReminderSampleFileList
         * @request GET:/api/ntl/admin/v1/catalog/atp/register-reminder-sample-file
         */
        ntlAdminV1CatalogAtpRegisterReminderSampleFileList: (params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/ntl/admin/v1/catalog/atp/register-reminder-sample-file`,
                method: 'GET',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AvailableToPurchase
         * @name NtlAdminV1CatalogAtpSetVendorDisplayNamePartialUpdate
         * @request PATCH:/api/ntl/admin/v1/catalog/atp/set-vendor-display-name
         */
        ntlAdminV1CatalogAtpSetVendorDisplayNamePartialUpdate: (
            query: {
                product_id: string
            },
            params: RequestParams = {}
        ) =>
            this.request<BooleanActionResultSuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/admin/v1/catalog/atp/set-vendor-display-name`,
                method: 'PATCH',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags UnsalableQty
         * @name NtlAdminV1CatalogAtpUnsalableQtyProcessCreate
         * @summary Create a unsalable qty import process using excel file
         * @request POST:/api/ntl/admin/v1/catalog/atp/unsalable-qty-process
         */
        ntlAdminV1CatalogAtpUnsalableQtyProcessCreate: (
            data: {
                /** @format binary */
                file?: File
                /** @default true */
                include_first_row?: boolean
                /** @default true */
                partially_enable?: boolean
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/api/ntl/admin/v1/catalog/atp/unsalable-qty-process`,
                method: 'POST',
                body: data,
                type: ContentType.FormData,
                ...params,
            }),

        /**
         * No description
         *
         * @tags UnsalableQty
         * @name NtlAdminV1CatalogAtpUnsalableQtySampleFileList
         * @summary Download unsalable qty import sample file
         * @request GET:/api/ntl/admin/v1/catalog/atp/unsalable-qty-sample-file
         */
        ntlAdminV1CatalogAtpUnsalableQtySampleFileList: (params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/ntl/admin/v1/catalog/atp/unsalable-qty-sample-file`,
                method: 'GET',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Config
         * @name NtlAdminV1ConfigsShippingCreate
         * @request POST:/api/ntl/admin/v1/configs/shipping
         */
        ntlAdminV1ConfigsShippingCreate: (data: SetShippingConfigurationsRequest, params: RequestParams = {}) =>
            this.request<SetShippingConfigurationsViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/admin/v1/configs/shipping`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ErpAtp
         * @name NtlAdminV1ErpErpAtpList
         * @request GET:/api/ntl/admin/v1/erp/erp-atp
         */
        ntlAdminV1ErpErpAtpList: (
            query?: {
                /**
                 * @format int32
                 * @min 1
                 * @max 2147483647
                 * @default 1
                 */
                page_number?: number
                /**
                 * @format int32
                 * @min 1
                 * @max 100
                 * @default 10
                 */
                page_size?: number
                atp_id?: string
                order_no?: string
                /** @format date-time */
                from?: string
                /** @format date-time */
                to?: string
                is_approved?: boolean
                supply_type?: SupplyType
            },
            params: RequestParams = {}
        ) =>
            this.request<GetErpAtpItemListViewModelKibaPaginationViewModelSuccessEnvelop, EnvelopError>({
                path: `/api/ntl/admin/v1/erp/erp-atp`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ErpAtp
         * @name NtlAdminV1ErpErpAtpExcelList
         * @request GET:/api/ntl/admin/v1/erp/erp-atp/_excel
         */
        ntlAdminV1ErpErpAtpExcelList: (
            query?: {
                atp_id?: string
                order_no?: string
                /** @format date-time */
                from?: string
                /** @format date-time */
                to?: string
                is_approved?: boolean
                supply_type?: SupplyType
            },
            params: RequestParams = {}
        ) =>
            this.request<GetErpAtpItemListViewModelKibaPaginationViewModel, EnvelopError>({
                path: `/api/ntl/admin/v1/erp/erp-atp/_excel`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ErpAtp
         * @name NtlAdminV1ErpErpAtpApproveUpdate
         * @request PUT:/api/ntl/admin/v1/erp/erp-atp/approve
         */
        ntlAdminV1ErpErpAtpApproveUpdate: (
            query?: {
                ids?: string[]
            },
            params: RequestParams = {}
        ) =>
            this.request<BooleanSuccessEnvelop, EnvelopError>({
                path: `/api/ntl/admin/v1/erp/erp-atp/approve`,
                method: 'PUT',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags GoldPrice
         * @name NtlAdminV1GoldPriceCreate
         * @request POST:/api/ntl/admin/v1/gold-price
         */
        ntlAdminV1GoldPriceCreate: (data: SetGoldPriceManuallyRequest, params: RequestParams = {}) =>
            this.request<SuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/admin/v1/gold-price`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags PointOfPurchase
         * @name NtlAdminV1PointOfPurchasesList
         * @request GET:/api/ntl/admin/v1/point-of-purchases
         */
        ntlAdminV1PointOfPurchasesList: (
            query?: {
                /**
                 * @format int32
                 * @default 1
                 */
                page_number?: number
                /**
                 * @format int32
                 * @min 1
                 * @max 300
                 * @default 10
                 */
                page_size?: number
                /** @default "" */
                query?: string
                id?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<PointOfPurchaseViewModelKibaPaginationViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/admin/v1/point-of-purchases`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags PointOfPurchase
         * @name NtlAdminV1PointOfPurchasesExcelCreate
         * @request POST:/api/ntl/admin/v1/point-of-purchases/_excel
         */
        ntlAdminV1PointOfPurchasesExcelCreate: (
            data: {
                /** @format binary */
                file?: File
                /** @default false */
                include_first_row?: boolean
            },
            params: RequestParams = {}
        ) =>
            this.request<void, FailureEnvelop>({
                path: `/api/ntl/admin/v1/point-of-purchases/_excel`,
                method: 'POST',
                body: data,
                type: ContentType.FormData,
                ...params,
            }),

        /**
         * No description
         *
         * @tags PointOfPurchase
         * @name NtlAdminV1PointOfPurchasesExcelList
         * @request GET:/api/ntl/admin/v1/point-of-purchases/_excel
         */
        ntlAdminV1PointOfPurchasesExcelList: (params: RequestParams = {}) =>
            this.request<void, FailureEnvelop>({
                path: `/api/ntl/admin/v1/point-of-purchases/_excel`,
                method: 'GET',
                ...params,
            }),

        /**
         * No description
         *
         * @tags PointOfPurchase
         * @name NtlAdminV1PointOfPurchasesExcelImportSampleFileList
         * @request GET:/api/ntl/admin/v1/point-of-purchases/_excel/import-sample-file
         */
        ntlAdminV1PointOfPurchasesExcelImportSampleFileList: (params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/ntl/admin/v1/point-of-purchases/_excel/import-sample-file`,
                method: 'GET',
                ...params,
            }),

        /**
         * No description
         *
         * @tags PointOfPurchase
         * @name NtlAdminV1PointOfPurchasesAllDelete
         * @request DELETE:/api/ntl/admin/v1/point-of-purchases/all
         */
        ntlAdminV1PointOfPurchasesAllDelete: (params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/ntl/admin/v1/point-of-purchases/all`,
                method: 'DELETE',
                ...params,
            }),

        /**
         * No description
         *
         * @tags PointOfPurchase
         * @name NtlAdminV1PointOfPurchasesIdDelete
         * @request DELETE:/api/ntl/admin/v1/point-of-purchases/id/{id}
         */
        ntlAdminV1PointOfPurchasesIdDelete: (id: string, params: RequestParams = {}) =>
            this.request<void, FailureEnvelop>({
                path: `/api/ntl/admin/v1/point-of-purchases/id/${id}`,
                method: 'DELETE',
                ...params,
            }),

        /**
         * No description
         *
         * @tags PricingRequest
         * @name NtlAdminV1PricingRequestsList
         * @request GET:/api/ntl/admin/v1/pricing-requests
         */
        ntlAdminV1PricingRequestsList: (
            query?: {
                /**
                 * @format int32
                 * @min 1
                 * @max 2147483647
                 * @default 1
                 */
                page_number?: number
                /**
                 * @format int32
                 * @min 1
                 * @max 100
                 * @default 10
                 */
                page_size?: number
                title?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<GetPricingRequestsViewModelKibaPaginationViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/admin/v1/pricing-requests`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags PricingRequest
         * @name NtlAdminV1PricingRequestsAddPricingRequestCreate
         * @request POST:/api/ntl/admin/v1/pricing-requests/add-pricing-request
         */
        ntlAdminV1PricingRequestsAddPricingRequestCreate: (
            data: AddPricingRequestRequest,
            params: RequestParams = {}
        ) =>
            this.request<AddPricingRequestViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/admin/v1/pricing-requests/add-pricing-request`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags PricingRequest
         * @name NtlAdminV1PricingRequestsBrandMaxDiscountsList
         * @request GET:/api/ntl/admin/v1/pricing-requests/brand-max-discounts
         */
        ntlAdminV1PricingRequestsBrandMaxDiscountsList: (
            query?: {
                /**
                 * @format int32
                 * @min 1
                 * @max 2147483647
                 * @default 1
                 */
                page_number?: number
                /**
                 * @format int32
                 * @min 1
                 * @max 100
                 * @default 10
                 */
                page_size?: number
            },
            params: RequestParams = {}
        ) =>
            this.request<GetBrandMaxDiscountViewModelKibaPaginationViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/admin/v1/pricing-requests/brand-max-discounts`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags PricingRequest
         * @name NtlAdminV1PricingRequestsPricingRequestResultsList
         * @request GET:/api/ntl/admin/v1/pricing-requests/pricing-request-results
         */
        ntlAdminV1PricingRequestsPricingRequestResultsList: (
            query?: {
                /**
                 * @format int32
                 * @min 1
                 * @max 2147483647
                 * @default 1
                 */
                page_number?: number
                /**
                 * @format int32
                 * @min 1
                 * @max 100
                 * @default 10
                 */
                page_size?: number
                /** @format int32 */
                request_id?: number
            },
            params: RequestParams = {}
        ) =>
            this.request<GetPricingRequestResultViewModelKibaPaginationViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/admin/v1/pricing-requests/pricing-request-results`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Product
         * @name NtlAdminV1ProductProposalsList
         * @summary Get Product Item Proposals by productId
         * @request GET:/api/ntl/admin/v1/product-proposals
         */
        ntlAdminV1ProductProposalsList: (
            query: {
                ids: string[]
            },
            params: RequestParams = {}
        ) =>
            this.request<GetProductItemProposalQueryItemViewModelArraySuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/admin/v1/product-proposals`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Product
         * @name NtlAdminV1ProductsSyncToSearchiaCreate
         * @request POST:/api/ntl/admin/v1/products/sync-to-searchia
         */
        ntlAdminV1ProductsSyncToSearchiaCreate: (
            query?: {
                product_id?: string
                brand_slug?: string
                tag_slug?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<SyncProductToSearchiaViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/admin/v1/products/sync-to-searchia`,
                method: 'POST',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Promotion
         * @name NtlAdminV1PromotionsList
         * @request GET:/api/ntl/admin/v1/promotions
         */
        ntlAdminV1PromotionsList: (
            query?: {
                /**
                 * @format int32
                 * @default 1
                 */
                page_number?: number
                /**
                 * @format int32
                 * @min 1
                 * @max 300
                 * @default 10
                 */
                page_size?: number
                id?: string
                /** @default "" */
                title?: string
                /** @format date-time */
                from?: string
                /** @format date-time */
                to?: string
                status?: PromotionStatus
                voucher_id?: string
                cost_info_cost_center?: string
                cost_info_cost_type?: string
                cost_info_campaign?: string
                offer_due_type?: PromotionOfferDueType
                offer_type?: PromotionOfferType
                has_key?: boolean
            },
            params: RequestParams = {}
        ) =>
            this.request<PromotionListItemViewModelKibaPaginationViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/admin/v1/promotions`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Promotion
         * @name NtlAdminV1PromotionsDelete
         * @request DELETE:/api/ntl/admin/v1/promotions/{id}
         */
        ntlAdminV1PromotionsDelete: (id: string, params: RequestParams = {}) =>
            this.request<void, FailureEnvelop>({
                path: `/api/ntl/admin/v1/promotions/${id}`,
                method: 'DELETE',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Promotion
         * @name NtlAdminV1PromotionsSuspendPartialUpdate
         * @request PATCH:/api/ntl/admin/v1/promotions/{promotionId}/suspend
         */
        ntlAdminV1PromotionsSuspendPartialUpdate: (promotionId: string, params: RequestParams = {}) =>
            this.request<void, FailureEnvelop>({
                path: `/api/ntl/admin/v1/promotions/${promotionId}/suspend`,
                method: 'PATCH',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Promotion
         * @name NtlAdminV1PromotionsUnSuspendPartialUpdate
         * @request PATCH:/api/ntl/admin/v1/promotions/{promotionId}/un-suspend
         */
        ntlAdminV1PromotionsUnSuspendPartialUpdate: (promotionId: string, params: RequestParams = {}) =>
            this.request<void, FailureEnvelop>({
                path: `/api/ntl/admin/v1/promotions/${promotionId}/un-suspend`,
                method: 'PATCH',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Promotion
         * @name NtlAdminV1PromotionsAuditRegisterReminderCreate
         * @request POST:/api/ntl/admin/v1/promotions/audit-register-reminder
         */
        ntlAdminV1PromotionsAuditRegisterReminderCreate: (
            data: AuditRegisterReminderRequest,
            params: RequestParams = {}
        ) =>
            this.request<PromotionIdSuccessEnvelop, ErrorFailureEnvelop>({
                path: `/api/ntl/admin/v1/promotions/audit-register-reminder`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Promotion
         * @name NtlAdminV1PromotionsCrmList
         * @request GET:/api/ntl/admin/v1/promotions/crm
         */
        ntlAdminV1PromotionsCrmList: (
            query?: {
                /**
                 * @format int32
                 * @default 1
                 */
                page_number?: number
                /**
                 * @format int32
                 * @min 1
                 * @max 300
                 * @default 10
                 */
                page_size?: number
                /** @default "" */
                title?: string
                /** @format date-time */
                from?: string
                /** @format date-time */
                to?: string
                voucher_code?: string
                has_key?: boolean
            },
            params: RequestParams = {}
        ) =>
            this.request<GetCrmPromotionListViewModelKibaPaginationViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/admin/v1/promotions/crm`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Promotion
         * @name NtlAdminV1PromotionsCrmCreate
         * @request POST:/api/ntl/admin/v1/promotions/crm
         */
        ntlAdminV1PromotionsCrmCreate: (data: CreateCrmPromotionRequestViewModel, params: RequestParams = {}) =>
            this.request<CreateCrmPromotionViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/admin/v1/promotions/crm`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Promotion
         * @name NtlAdminV1PromotionsCrmIdDelete
         * @request DELETE:/api/ntl/admin/v1/promotions/crm/id/{id}
         */
        ntlAdminV1PromotionsCrmIdDelete: (id: string, params: RequestParams = {}) =>
            this.request<void, FailureEnvelop>({
                path: `/api/ntl/admin/v1/promotions/crm/id/${id}`,
                method: 'DELETE',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Promotion
         * @name NtlAdminV1PromotionsFixPriceCreate
         * @request POST:/api/ntl/admin/v1/promotions/fix-price
         */
        ntlAdminV1PromotionsFixPriceCreate: (
            data: CreateFixPricePromotionRequestViewModel,
            params: RequestParams = {}
        ) =>
            this.request<PromotionViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/admin/v1/promotions/fix-price`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Promotion
         * @name NtlAdminV1PromotionsFreeShippingCreate
         * @request POST:/api/ntl/admin/v1/promotions/free-shipping
         */
        ntlAdminV1PromotionsFreeShippingCreate: (
            data: CreateFreeShippingPromotionRequestViewModel,
            params: RequestParams = {}
        ) =>
            this.request<PromotionViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/admin/v1/promotions/free-shipping`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Promotion
         * @name NtlAdminV1PromotionsGiftCreate
         * @request POST:/api/ntl/admin/v1/promotions/gift
         */
        ntlAdminV1PromotionsGiftCreate: (data: CreateGiftPromotionRequestViewModel, params: RequestParams = {}) =>
            this.request<PromotionViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/admin/v1/promotions/gift`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Promotion
         * @name NtlAdminV1PromotionsPercentagePriceCreate
         * @request POST:/api/ntl/admin/v1/promotions/percentage-price
         */
        ntlAdminV1PromotionsPercentagePriceCreate: (
            data: CreatePercentagePricePromotionRequestViewModel,
            params: RequestParams = {}
        ) =>
            this.request<PromotionViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/admin/v1/promotions/percentage-price`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Vendor
         * @name NtlAdminV1VendorsList
         * @request GET:/api/ntl/admin/v1/vendors
         */
        ntlAdminV1VendorsList: (
            query?: {
                /**
                 * @format int32
                 * @default 1
                 */
                page_number?: number
                /**
                 * @format int32
                 * @min 1
                 * @max 300
                 * @default 10
                 */
                page_size?: number
                vendor_id?: string
                vendor_name?: string
                vendor_display_name?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<VendorPaginationListByFilterViewModelPaginationSuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/admin/v1/vendors`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Vendor
         * @name NtlAdminV1VendorsDetail
         * @request GET:/api/ntl/admin/v1/vendors/{vendorId}
         */
        ntlAdminV1VendorsDetail: (vendorId: string, params: RequestParams = {}) =>
            this.request<VendorItemViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/admin/v1/vendors/${vendorId}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Vendor
         * @name NtlAdminV1VendorsUpdateDisplayNameUpdate
         * @request PUT:/api/ntl/admin/v1/vendors/update-display-name
         */
        ntlAdminV1VendorsUpdateDisplayNameUpdate: (data: UpdateVendorDisplayNameRequest, params: RequestParams = {}) =>
            this.request<SuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/admin/v1/vendors/update-display-name`,
                method: 'PUT',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Vca
         * @name NtlAdminV1VendorsVcaList
         * @summary Get all active vca
         * @request GET:/api/ntl/admin/v1/vendors/vca
         */
        ntlAdminV1VendorsVcaList: (
            query?: {
                /**
                 * @format int32
                 * @default 1
                 */
                page_number?: number
                /**
                 * @format int32
                 * @default 10
                 */
                page_size?: number
                vendor_id?: string
                atp_id?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<VcaListItemViewModelKibaPaginationViewModelSuccessEnvelop, any>({
                path: `/api/ntl/admin/v1/vendors/vca`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Vca
         * @name NtlAdminV1VendorsVcaExcelList
         * @summary Export active VCA
         * @request GET:/api/ntl/admin/v1/vendors/vca/_excel
         */
        ntlAdminV1VendorsVcaExcelList: (
            query?: {
                vendor_id?: string
                atp_id?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/api/ntl/admin/v1/vendors/vca/_excel`,
                method: 'GET',
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Vca
         * @name NtlAdminV1VendorsVcaBatchDeleteProcessCreate
         * @summary Create a batch delete process using excel file
         * @request POST:/api/ntl/admin/v1/vendors/vca/batch-delete-process
         */
        ntlAdminV1VendorsVcaBatchDeleteProcessCreate: (
            data: {
                /** @format binary */
                file?: File
                /** @default true */
                include_first_row?: boolean
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/api/ntl/admin/v1/vendors/vca/batch-delete-process`,
                method: 'POST',
                body: data,
                type: ContentType.FormData,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Vca
         * @name NtlAdminV1VendorsVcaBatchDeleteSampleFileList
         * @summary Download Batch delete sample file
         * @request GET:/api/ntl/admin/v1/vendors/vca/batch-delete-sample-file
         */
        ntlAdminV1VendorsVcaBatchDeleteSampleFileList: (params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/ntl/admin/v1/vendors/vca/batch-delete-sample-file`,
                method: 'GET',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Vca
         * @name NtlAdminV1VendorsVcaBatchImportProcessCreate
         * @summary Create a batch import process using excel file
         * @request POST:/api/ntl/admin/v1/vendors/vca/batch-import-process
         */
        ntlAdminV1VendorsVcaBatchImportProcessCreate: (
            data: {
                /** @format binary */
                file?: File
                /** @default true */
                include_first_row?: boolean
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/api/ntl/admin/v1/vendors/vca/batch-import-process`,
                method: 'POST',
                body: data,
                type: ContentType.FormData,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Vca
         * @name NtlAdminV1VendorsVcaImportSampleFileList
         * @summary Download batch import sample file
         * @request GET:/api/ntl/admin/v1/vendors/vca/import-sample-file
         */
        ntlAdminV1VendorsVcaImportSampleFileList: (params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/ntl/admin/v1/vendors/vca/import-sample-file`,
                method: 'GET',
                ...params,
            }),

        /**
         * No description
         *
         * @tags UpdateVcaWithLeadTime
         * @name NtlAdminV1VendorsVcaUpdateVcaWithLeadTimeCreate
         * @summary Create a update vca with leadTime process using excel file
         * @request POST:/api/ntl/admin/v1/vendors/vca/update-vca-with-leadTime
         */
        ntlAdminV1VendorsVcaUpdateVcaWithLeadTimeCreate: (
            data: {
                /** @format binary */
                file?: File
                /** @default true */
                include_first_row?: boolean
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/api/ntl/admin/v1/vendors/vca/update-vca-with-leadTime`,
                method: 'POST',
                body: data,
                type: ContentType.FormData,
                ...params,
            }),

        /**
         * No description
         *
         * @tags UpdateVcaWithLeadTime
         * @name NtlAdminV1VendorsVcaUpdateVcaWithLeadTimeSampleFileList
         * @summary Download update vca with leadTime sample file
         * @request GET:/api/ntl/admin/v1/vendors/vca/update-vca-with-leadTime-sample-file
         */
        ntlAdminV1VendorsVcaUpdateVcaWithLeadTimeSampleFileList: (params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/ntl/admin/v1/vendors/vca/update-vca-with-leadTime-sample-file`,
                method: 'GET',
                ...params,
            }),

        /**
         * No description
         *
         * @tags VoucherAdmin
         * @name NtlAdminV1VouchersList
         * @request GET:/api/ntl/admin/v1/vouchers
         */
        ntlAdminV1VouchersList: (
            query?: {
                /**
                 * @format int32
                 * @default 1
                 */
                page_number?: number
                /**
                 * @format int32
                 * @min 1
                 * @max 300
                 * @default 10
                 */
                page_size?: number
                /** @default "" */
                query?: string
                /** @format date-time */
                from?: string
                /** @format date-time */
                to?: string
                type?: VoucherType
            },
            params: RequestParams = {}
        ) =>
            this.request<VoucherDtoViewModelKibaPaginationViewModelSuccessEnvelop, any>({
                path: `/api/ntl/admin/v1/vouchers`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags VoucherAdmin
         * @name NtlAdminV1VouchersDelete
         * @request DELETE:/api/ntl/admin/v1/vouchers/{id}
         */
        ntlAdminV1VouchersDelete: (id: number, params: RequestParams = {}) =>
            this.request<UniqueVoucherViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/admin/v1/vouchers/${id}`,
                method: 'DELETE',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags VoucherAdmin
         * @name NtlAdminV1VouchersUsageLogsList
         * @request GET:/api/ntl/admin/v1/vouchers/{id}/usage-logs
         */
        ntlAdminV1VouchersUsageLogsList: (id: number, params: RequestParams = {}) =>
            this.request<VoucherDtoViewModelKibaPaginationViewModel, any>({
                path: `/api/ntl/admin/v1/vouchers/${id}/usage-logs`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags VoucherAdmin
         * @name NtlAdminV1VouchersSuspendPartialUpdate
         * @request PATCH:/api/ntl/admin/v1/vouchers/{voucherId}/suspend
         */
        ntlAdminV1VouchersSuspendPartialUpdate: (voucherId: string, params: RequestParams = {}) =>
            this.request<void, FailureEnvelop>({
                path: `/api/ntl/admin/v1/vouchers/${voucherId}/suspend`,
                method: 'PATCH',
                ...params,
            }),

        /**
         * No description
         *
         * @tags VoucherAdmin
         * @name NtlAdminV1VouchersUnSuspendPartialUpdate
         * @request PATCH:/api/ntl/admin/v1/vouchers/{voucherId}/un-suspend
         */
        ntlAdminV1VouchersUnSuspendPartialUpdate: (voucherId: string, params: RequestParams = {}) =>
            this.request<void, FailureEnvelop>({
                path: `/api/ntl/admin/v1/vouchers/${voucherId}/un-suspend`,
                method: 'PATCH',
                ...params,
            }),

        /**
         * No description
         *
         * @tags VoucherAdmin
         * @name NtlAdminV1VouchersCodeDetail
         * @request GET:/api/ntl/admin/v1/vouchers/code/{code}
         */
        ntlAdminV1VouchersCodeDetail: (code: string, params: RequestParams = {}) =>
            this.request<any, FailureEnvelop>({
                path: `/api/ntl/admin/v1/vouchers/code/${code}`,
                method: 'GET',
                ...params,
            }),

        /**
         * No description
         *
         * @tags VoucherAdmin
         * @name NtlAdminV1VouchersReusableCreate
         * @request POST:/api/ntl/admin/v1/vouchers/reusable
         */
        ntlAdminV1VouchersReusableCreate: (data: CreateReusableVoucherCommandViewModel, params: RequestParams = {}) =>
            this.request<ReusableVoucherViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/admin/v1/vouchers/reusable`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags VoucherAdmin
         * @name NtlAdminV1VouchersUniquesCreate
         * @request POST:/api/ntl/admin/v1/vouchers/uniques
         */
        ntlAdminV1VouchersUniquesCreate: (data: CreateUniqueVoucherCommandViewModel, params: RequestParams = {}) =>
            this.request<UniqueVoucherViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/admin/v1/vouchers/uniques`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags VoucherAdmin
         * @name NtlAdminV1VouchersUniquesCodesList
         * @request GET:/api/ntl/admin/v1/vouchers/uniques/{id}/codes
         */
        ntlAdminV1VouchersUniquesCodesList: (id: number, params: RequestParams = {}) =>
            this.request<string[], any>({
                path: `/api/ntl/admin/v1/vouchers/uniques/${id}/codes`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Erp
         * @name NtlErpV1LotAtpAvailableLotsList
         * @request GET:/api/ntl/erp/v1/lot/atp/available-lots
         */
        ntlErpV1LotAtpAvailableLotsList: (
            query: {
                atp_ids: number[]
            },
            params: RequestParams = {}
        ) =>
            this.request<GetAvailableLotsResponse, EnvelopError>({
                path: `/api/ntl/erp/v1/lot/atp/available-lots`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Erp
         * @name NtlErpV1LotSalableQtyDecreaseCreate
         * @request POST:/api/ntl/erp/v1/lot/salable-qty/decrease
         */
        ntlErpV1LotSalableQtyDecreaseCreate: (data: DecreaseLotSalableQtyRequest, params: RequestParams = {}) =>
            this.request<DecreaseLotSalableQtyViewModelSuccessEnvelop, EnvelopError>({
                path: `/api/ntl/erp/v1/lot/salable-qty/decrease`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Erp
         * @name NtlErpV1LotSalableQtyIncreaseCreate
         * @request POST:/api/ntl/erp/v1/lot/salable-qty/increase
         */
        ntlErpV1LotSalableQtyIncreaseCreate: (data: IncreaseLotSalableQtyRequest, params: RequestParams = {}) =>
            this.request<SuccessEnvelop, EnvelopError>({
                path: `/api/ntl/erp/v1/lot/salable-qty/increase`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ApplicationConfiguration
         * @name NtlV1AppConfigurationsList
         * @request GET:/api/ntl/v1/app/configurations
         */
        ntlV1AppConfigurationsList: (params: RequestParams = {}) =>
            this.request<ApplicationConfigurationViewModelSuccessEnvelop, any>({
                path: `/api/ntl/v1/app/configurations`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Cart
         * @name NtlV1CartsMyList
         * @request GET:/api/ntl/v1/carts/_my
         */
        ntlV1CartsMyList: (
            query?: {
                'fake-change'?: CartItemChangeType
            },
            params: RequestParams = {}
        ) =>
            this.request<CartViewModelSuccessEnvelop, FailureEnvelop | void>({
                path: `/api/ntl/v1/carts/_my`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Cart
         * @name NtlV1CartsMyAlsoBoughtList
         * @request GET:/api/ntl/v1/carts/_my/also-bought
         */
        ntlV1CartsMyAlsoBoughtList: (params: RequestParams = {}) =>
            this.request<ProductListViewModelListSuccessEnvelop, any>({
                path: `/api/ntl/v1/carts/_my/also-bought`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Cart
         * @name NtlV1CartsMyItemsCreate
         * @request POST:/api/ntl/v1/carts/_my/items
         */
        ntlV1CartsMyItemsCreate: (data: AddToCartRequest, params: RequestParams = {}) =>
            this.request<CartViewModelSuccessEnvelop, FailureEnvelop | void>({
                path: `/api/ntl/v1/carts/_my/items`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Cart
         * @name NtlV1CartsMyItemsDecCreate
         * @request POST:/api/ntl/v1/carts/_my/items/{itemId}/dec
         */
        ntlV1CartsMyItemsDecCreate: (itemId: string, params: RequestParams = {}) =>
            this.request<CartViewModelSuccessEnvelop, FailureEnvelop | void>({
                path: `/api/ntl/v1/carts/_my/items/${itemId}/dec`,
                method: 'POST',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Cart
         * @name NtlV1CartsMyItemsIncCreate
         * @request POST:/api/ntl/v1/carts/_my/items/{itemId}/inc
         */
        ntlV1CartsMyItemsIncCreate: (itemId: string, params: RequestParams = {}) =>
            this.request<CartViewModelSuccessEnvelop, FailureEnvelop | void>({
                path: `/api/ntl/v1/carts/_my/items/${itemId}/inc`,
                method: 'POST',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Cart
         * @name NtlV1CartsMyItemsCountList
         * @request GET:/api/ntl/v1/carts/_my/items/count
         */
        ntlV1CartsMyItemsCountList: (params: RequestParams = {}) =>
            this.request<Int32SuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/v1/carts/_my/items/count`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Cart
         * @name NtlV1CartsMyVouchersDelete
         * @request DELETE:/api/ntl/v1/carts/_my/vouchers
         */
        ntlV1CartsMyVouchersDelete: (params: RequestParams = {}) =>
            this.request<CartViewModelSuccessEnvelop, FailureEnvelop | void>({
                path: `/api/ntl/v1/carts/_my/vouchers`,
                method: 'DELETE',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Cart
         * @name NtlV1CartsMyVouchersCreate
         * @summary Validate and add voucher
         * @request POST:/api/ntl/v1/carts/_my/vouchers
         */
        ntlV1CartsMyVouchersCreate: (data: AddVoucherToCartRequest, params: RequestParams = {}) =>
            this.request<
                CartViewModelSuccessEnvelop,
                PromotionImperfectViewModelFailureEnvelop | FailureEnvelop | void
            >({
                path: `/api/ntl/v1/carts/_my/vouchers`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Brand
         * @name NtlV1CatalogBrandsList
         * @summary Get paginated list of brands
         * @request GET:/api/ntl/v1/catalog/brands
         */
        ntlV1CatalogBrandsList: (
            query?: {
                /** @default "" */
                query?: string
                /**
                 * @format int32
                 * @default 1
                 */
                page_number?: number
                /**
                 * @format int32
                 * @min 1
                 * @max 300
                 * @default 10
                 */
                page_size?: number
                analytics_tag?: AnalyticsTagType
            },
            params: RequestParams = {}
        ) =>
            this.request<BrandListingItemViewModelKibaPaginationViewModelSuccessEnvelop, any>({
                path: `/api/ntl/v1/catalog/brands`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Brand
         * @name NtlV1CatalogBrandsSlugCategoryDetail
         * @request GET:/api/ntl/v1/catalog/brands/slug/{brandSlug}/category/{categorySlug}
         */
        ntlV1CatalogBrandsSlugCategoryDetail: (brandSlug: string, categorySlug: string, params: RequestParams = {}) =>
            this.request<GetBrandCategoryViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/v1/catalog/brands/slug/${brandSlug}/category/${categorySlug}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Brand
         * @name NtlV1CatalogBrandsSlugDetail
         * @summary Get brand details by slug
         * @request GET:/api/ntl/v1/catalog/brands/slug/{slug}
         */
        ntlV1CatalogBrandsSlugDetail: (slug: string, params: RequestParams = {}) =>
            this.request<GetBrandBySlugViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/v1/catalog/brands/slug/${slug}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Category
         * @name NtlV1CatalogCategoriesSlugDetail
         * @summary Get category details by slug
         * @request GET:/api/ntl/v1/catalog/categories/slug/{slug}
         */
        ntlV1CatalogCategoriesSlugDetail: (slug: string, params: RequestParams = {}) =>
            this.request<GetCategoryBySlugViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/v1/catalog/categories/slug/${slug}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags PriceRange
         * @name NtlV1CatalogPriceRangesBrandDetail
         * @request GET:/api/ntl/v1/catalog/price-ranges/brand/{slug}
         */
        ntlV1CatalogPriceRangesBrandDetail: (
            slug: string,
            query?: {
                analytics_tag?: AnalyticsTagType
            },
            params: RequestParams = {}
        ) =>
            this.request<GetPriceRangeViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/v1/catalog/price-ranges/brand/${slug}`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags PriceRange
         * @name NtlV1CatalogPriceRangesCategoryDetail
         * @request GET:/api/ntl/v1/catalog/price-ranges/category/{cat1Slug}
         */
        ntlV1CatalogPriceRangesCategoryDetail: (
            cat1Slug: string,
            query?: {
                cat2Slug?: string
                cat3Slug?: string
                analytics_tag?: AnalyticsTagType
            },
            params: RequestParams = {}
        ) =>
            this.request<GetPriceRangeViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/v1/catalog/price-ranges/category/${cat1Slug}`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags PriceRange
         * @name NtlV1CatalogPriceRangesCategoryDetail2
         * @request GET:/api/ntl/v1/catalog/price-ranges/category/{cat1Slug}/{cat2Slug}
         * @originalName ntlV1CatalogPriceRangesCategoryDetail
         * @duplicate
         */
        ntlV1CatalogPriceRangesCategoryDetail2: (
            cat1Slug: string,
            cat2Slug: string,
            query?: {
                cat3Slug?: string
                analytics_tag?: AnalyticsTagType
            },
            params: RequestParams = {}
        ) =>
            this.request<GetPriceRangeViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/v1/catalog/price-ranges/category/${cat1Slug}/${cat2Slug}`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags PriceRange
         * @name NtlV1CatalogPriceRangesCategoryDetail3
         * @request GET:/api/ntl/v1/catalog/price-ranges/category/{cat1Slug}/{cat2Slug}/{cat3Slug}
         * @originalName ntlV1CatalogPriceRangesCategoryDetail
         * @duplicate
         */
        ntlV1CatalogPriceRangesCategoryDetail3: (
            cat1Slug: string,
            cat2Slug: string,
            cat3Slug: string,
            query?: {
                analytics_tag?: AnalyticsTagType
            },
            params: RequestParams = {}
        ) =>
            this.request<GetPriceRangeViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/v1/catalog/price-ranges/category/${cat1Slug}/${cat2Slug}/${cat3Slug}`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags PriceRange
         * @name NtlV1CatalogPriceRangesSearchList
         * @request GET:/api/ntl/v1/catalog/price-ranges/search
         */
        ntlV1CatalogPriceRangesSearchList: (
            query?: {
                analytics_tag?: AnalyticsTagType
            },
            params: RequestParams = {}
        ) =>
            this.request<GetPriceRangeViewModelSuccessEnvelop, any>({
                path: `/api/ntl/v1/catalog/price-ranges/search`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags PriceRange
         * @name NtlV1CatalogPriceRangesTagDetail
         * @request GET:/api/ntl/v1/catalog/price-ranges/tag/{slug}
         */
        ntlV1CatalogPriceRangesTagDetail: (
            slug: string,
            query?: {
                analytics_tag?: AnalyticsTagType
            },
            params: RequestParams = {}
        ) =>
            this.request<GetPriceRangeViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/v1/catalog/price-ranges/tag/${slug}`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Search
         * @name NtlV1CatalogSearchList
         * @summary Search catalog
         * @request GET:/api/ntl/v1/catalog/search
         */
        ntlV1CatalogSearchList: (
            query: {
                /** @format uuid */
                ut: string
                /** @maxLength 100 */
                query?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<SearchViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/v1/catalog/search`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Tag
         * @name NtlV1CatalogTagsSlugDetail
         * @summary Get tag details by slug
         * @request GET:/api/ntl/v1/catalog/tags/slug/{slug}
         */
        ntlV1CatalogTagsSlugDetail: (slug: string, params: RequestParams = {}) =>
            this.request<GetTagBySlugViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/v1/catalog/tags/slug/${slug}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Layout
         * @name NtlV1LayoutMenuList
         * @summary Get menu data of home page layout
         * @request GET:/api/ntl/v1/layout/menu
         */
        ntlV1LayoutMenuList: (params: RequestParams = {}) =>
            this.request<MenuViewModelSuccessEnvelop, any>({
                path: `/api/ntl/v1/layout/menu`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Newsletter
         * @name NtlV1NewsletterCreate
         * @summary Subscribe to newsletter or ignore if subscription already exists
         * @request POST:/api/ntl/v1/newsletter
         */
        ntlV1NewsletterCreate: (data: SubscribeNewsletterRequest, params: RequestParams = {}) =>
            this.request<void, FailureEnvelop | void>({
                path: `/api/ntl/v1/newsletter`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Order
         * @name NtlV1OrdersCreate
         * @request POST:/api/ntl/v1/orders
         */
        ntlV1OrdersCreate: (data: CreateOrderRequest, params: RequestParams = {}) =>
            this.request<CreateOrderViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/v1/orders`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Order
         * @name NtlV1OrdersDetail
         * @request GET:/api/ntl/v1/orders/{orderId}
         */
        ntlV1OrdersDetail: (
            orderId: string,
            query?: {
                status?: string
                /** @format uuid */
                payment_id?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<PaymentCallbackViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/v1/orders/${orderId}`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Order
         * @name NtlV1OrdersCreate2
         * @request POST:/api/ntl/v1/orders/{orderId}
         * @originalName ntlV1OrdersCreate
         * @duplicate
         */
        ntlV1OrdersCreate2: (
            orderId: string,
            query?: {
                status?: string
                /** @format uuid */
                payment_id?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<PaymentCallbackViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/v1/orders/${orderId}`,
                method: 'POST',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Order
         * @name NtlV1OrdersPaymentOptionsList
         * @request GET:/api/ntl/v1/orders/payment-options
         */
        ntlV1OrdersPaymentOptionsList: (
            query?: {
                /** @format int64 */
                time_slot_id?: number
                /** @format int64 */
                address_id?: number
                /** @format int32 */
                shipping_method_id?: number
                /** @format int32 */
                distribution_center_id?: number
            },
            params: RequestParams = {}
        ) =>
            this.request<GetPaymentOptionsViewModelArraySuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/v1/orders/payment-options`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Order
         * @name NtlV1PaymentsDetail
         * @request GET:/api/ntl/v1/payments/{id}
         */
        ntlV1PaymentsDetail: (id: string, params: RequestParams = {}) =>
            this.request<PaymentFinalStatusViewModelSuccessEnvelop, EnvelopError>({
                path: `/api/ntl/v1/payments/${id}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Order
         * @name NtlV1PaymentsCancelCreate
         * @request POST:/api/ntl/v1/payments/cancel
         */
        ntlV1PaymentsCancelCreate: (
            data: {
                /** @format uuid */
                reference_id: string
                /** @format uuid */
                payment_id: string
                status: string
            },
            params: RequestParams = {}
        ) =>
            this.request<void, FailureEnvelop>({
                path: `/api/ntl/v1/payments/cancel`,
                method: 'POST',
                body: data,
                type: ContentType.FormData,
                ...params,
            }),

        /**
         * No description
         *
         * @tags PointOfPurchase
         * @name NtlV1PointOfPurchasesList
         * @request GET:/api/ntl/v1/point-of-purchases
         */
        ntlV1PointOfPurchasesList: (params: RequestParams = {}) =>
            this.request<PointOfPurchaseShopViewModelListSuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/v1/point-of-purchases`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Product
         * @name NtlV1ProductsList
         * @summary Get product list and facets
         * @request GET:/api/ntl/v1/products
         */
        ntlV1ProductsList: (
            query?: {
                /** @format uuid */
                ut?: string
                ic?: boolean
                /**
                 * @format int32
                 * @default 1
                 */
                page_number?: number
                /**
                 * @format int32
                 * @min 1
                 * @max 300
                 * @default 10
                 */
                page_size?: number
                /** @default "" */
                query?: string
                has_stock?: boolean
                sort?: ProductListSort
                brand?: string[]
                color?: string[]
                cat?: string[]
                facet?: string[]
                /** @format int32 */
                from_price?: number
                /** @format int32 */
                to_price?: number
                brand_id?: string
                cat_id?: string
                tag_id?: string
                analytics_tag?: AnalyticsTagType
            },
            params: RequestParams = {}
        ) =>
            this.request<GetProductListViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/v1/products`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Product
         * @name NtlV1ProductsEmallsList
         * @request GET:/api/ntl/v1/products/_emalls
         */
        ntlV1ProductsEmallsList: (
            query?: {
                /** @format int32 */
                item_per_page?: number
                /** @format int32 */
                page?: number
            },
            params: RequestParams = {}
        ) =>
            this.request<ProductListForEmallsViewModel, FailureEnvelop>({
                path: `/api/ntl/v1/products/_emalls`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Product
         * @name NtlV1ProductsEmallsCreate
         * @request POST:/api/ntl/v1/products/_emalls
         */
        ntlV1ProductsEmallsCreate: (
            query?: {
                /** @format int32 */
                item_per_page?: number
                /** @format int32 */
                page?: number
            },
            params: RequestParams = {}
        ) =>
            this.request<ProductListForEmallsViewModel, FailureEnvelop>({
                path: `/api/ntl/v1/products/_emalls`,
                method: 'POST',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Product
         * @name NtlV1ProductsTorobCreate
         * @request POST:/api/ntl/v1/products/_torob
         */
        ntlV1ProductsTorobCreate: (
            data: {
                page_unique?: string
                page_url?: string
                page?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<ProductListForTorobViewModel, FailureEnvelop>({
                path: `/api/ntl/v1/products/_torob`,
                method: 'POST',
                body: data,
                type: ContentType.FormData,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Product
         * @name NtlV1ProductsCountList
         * @summary Get product count
         * @request GET:/api/ntl/v1/products/count
         */
        ntlV1ProductsCountList: (
            query?: {
                /** @format uuid */
                ut?: string
                ic?: boolean
                /**
                 * @format int32
                 * @default 1
                 */
                page_number?: number
                /**
                 * @format int32
                 * @min 1
                 * @max 300
                 * @default 10
                 */
                page_size?: number
                /** @default "" */
                query?: string
                has_stock?: boolean
                sort?: ProductListSort
                cat?: string[]
                facet?: string[]
                brand?: string[]
                color?: string[]
                /** @format int32 */
                from_price?: number
                /** @format int32 */
                to_price?: number
                brand_id?: string
                cat_id?: string
                tag_id?: string
                analytics_tag?: AnalyticsTagType
            },
            params: RequestParams = {}
        ) =>
            this.request<GetProductListViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/v1/products/count`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Product
         * @name NtlV1ProductsIdCommentsList
         * @request GET:/api/ntl/v1/products/id/{id}/comments
         */
        ntlV1ProductsIdCommentsList: (
            id: string,
            query?: {
                /**
                 * @format int32
                 * @default 1
                 */
                page_number?: number
                /**
                 * @format int32
                 * @min 1
                 * @max 300
                 * @default 10
                 */
                page_size?: number
                has_image?: boolean
            },
            params: RequestParams = {}
        ) =>
            this.request<CommentListViewModelKibaPaginationViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/v1/products/id/${id}/comments`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Product
         * @name NtlV1ProductsIdCommentsCreate
         * @request POST:/api/ntl/v1/products/id/{id}/comments
         */
        ntlV1ProductsIdCommentsCreate: (
            id: string,
            data: {
                /** @format int32 */
                rate: number
                /** @maxLength 1024 */
                description: string
                /** @format binary */
                image?: File
            },
            params: RequestParams = {}
        ) =>
            this.request<SuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/v1/products/id/${id}/comments`,
                method: 'POST',
                body: data,
                type: ContentType.FormData,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Product
         * @name NtlV1ProductsIdItemProposalsList
         * @request GET:/api/ntl/v1/products/id/{id}/item-proposals
         */
        ntlV1ProductsIdItemProposalsList: (id: number, params: RequestParams = {}) =>
            this.request<ItemProposalListSuccessEnvelop, any>({
                path: `/api/ntl/v1/products/id/${id}/item-proposals`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Product
         * @name NtlV1ProductsIdNotifyUserCreate
         * @request POST:/api/ntl/v1/products/id/{id}/notify-user
         */
        ntlV1ProductsIdNotifyUserCreate: (id: string, params: RequestParams = {}) =>
            this.request<void, FailureEnvelop>({
                path: `/api/ntl/v1/products/id/${id}/notify-user`,
                method: 'POST',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Product
         * @name NtlV1ProductsNoFacetList
         * @summary Get product by id
         * @request GET:/api/ntl/v1/products/no-facet
         */
        ntlV1ProductsNoFacetList: (
            query?: {
                /** list fo product ids */
                ids?: number[]
                sort?: ProductListSort
            },
            params: RequestParams = {}
        ) =>
            this.request<ProductListViewModelKibaPaginationViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/v1/products/no-facet`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Product
         * @name NtlV1ProductsSlugDetail
         * @request GET:/api/ntl/v1/products/slug/{slug}
         */
        ntlV1ProductsSlugDetail: (slug: string, params: RequestParams = {}) =>
            this.request<ProductViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/v1/products/slug/${slug}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Product
         * @name NtlV1ProductsSlugAlsoBoughtList
         * @request GET:/api/ntl/v1/products/slug/{slug}/also-bought
         */
        ntlV1ProductsSlugAlsoBoughtList: (slug: string, params: RequestParams = {}) =>
            this.request<ProductListViewModelListSuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/v1/products/slug/${slug}/also-bought`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Product
         * @name NtlV1ProductsSlugComplementaryList
         * @request GET:/api/ntl/v1/products/slug/{slug}/complementary
         */
        ntlV1ProductsSlugComplementaryList: (
            slug: string,
            query?: {
                analytics_tag?: AnalyticsTagType
            },
            params: RequestParams = {}
        ) =>
            this.request<ProductListViewModelListSuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/v1/products/slug/${slug}/complementary`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Product
         * @name NtlV1ProductsSlugSimilarList
         * @request GET:/api/ntl/v1/products/slug/{slug}/similar
         */
        ntlV1ProductsSlugSimilarList: (slug: string, params: RequestParams = {}) =>
            this.request<ProductListViewModelListSuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/v1/products/slug/${slug}/similar`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags SponsoredAd
         * @name NtlV1SponsoredAdsPdpList
         * @request GET:/api/ntl/v1/sponsored-ads/pdp
         */
        ntlV1SponsoredAdsPdpList: (
            query: {
                /** @format int32 */
                product_id: number
                /** @format uuid */
                ut?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<ProductListViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/v1/sponsored-ads/pdp`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Catalog
         * @name NtlV1StatsCatalogAddToCartCreate
         * @request POST:/api/ntl/v1/stats/catalog/add-to-cart
         */
        ntlV1StatsCatalogAddToCartCreate: (data: StatsAddToCartRequest, params: RequestParams = {}) =>
            this.request<void, FailureEnvelop>({
                path: `/api/ntl/v1/stats/catalog/add-to-cart`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Catalog
         * @name NtlV1StatsCatalogClickCreate
         * @request POST:/api/ntl/v1/stats/catalog/click
         */
        ntlV1StatsCatalogClickCreate: (data: ClickSearchItemRequest, params: RequestParams = {}) =>
            this.request<void, FailureEnvelop>({
                path: `/api/ntl/v1/stats/catalog/click`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Cart
         * @name NtlV1SubCartsMyList
         * @request GET:/api/ntl/v1/sub-carts/_my
         */
        ntlV1SubCartsMyList: (
            query?: {
                'fake-change'?: CartItemChangeType
            },
            params: RequestParams = {}
        ) =>
            this.request<GetSubCartViewModelSuccessEnvelop, FailureEnvelop | void>({
                path: `/api/ntl/v1/sub-carts/_my`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Vendor
         * @name NtlV1VendorAtpGoldLotCreate
         * @request POST:/api/ntl/v1/vendor/atp/{atpId}/gold-lot/{lotId}
         */
        ntlV1VendorAtpGoldLotCreate: (
            atpId: number,
            lotId: string,
            data: UpdateGoldLotRequest,
            params: RequestParams = {}
        ) =>
            this.request<UpdateGoldLotResponseSuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/v1/vendor/atp/${atpId}/gold-lot/${lotId}`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Vendor
         * @name NtlV1VendorGoldPriceList
         * @request GET:/api/ntl/v1/vendor/gold-price
         */
        ntlV1VendorGoldPriceList: (params: RequestParams = {}) =>
            this.request<GoldPriceViewModel, any>({
                path: `/api/ntl/v1/vendor/gold-price`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Vendor
         * @name NtlV1VendorLotsCreate
         * @request POST:/api/ntl/v1/vendor/lots
         */
        ntlV1VendorLotsCreate: (data: UpdateVendorLotRequestViewModel, params: RequestParams = {}) =>
            this.request<SuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/v1/vendor/lots`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Vendor
         * @name NtlV1VendorLotsList
         * @request GET:/api/ntl/v1/vendor/lots
         */
        ntlV1VendorLotsList: (
            query?: {
                /**
                 * @format int32
                 * @default 1
                 */
                page_number?: number
                /**
                 * @format int32
                 * @min 1
                 * @max 300
                 * @default 10
                 */
                page_size?: number
                atp_id?: string
                brand_id?: string
                product_id?: string
                stock_type?: StockType
                /** @default false */
                gold_atp?: boolean
            },
            params: RequestParams = {}
        ) =>
            this.request<VendorLotItemViewModelKibaPaginationViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/v1/vendor/lots`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Vendor
         * @name NtlV1VendorLotsUpdateBatchVendorLotsProcessCreate
         * @summary Create a update batch vendor lots process using excel file
         * @request POST:/api/ntl/v1/vendor/lots/update-batch-vendor-lots-process
         */
        ntlV1VendorLotsUpdateBatchVendorLotsProcessCreate: (
            data: {
                /** @format binary */
                file?: File
                /** @default true */
                include_first_row?: boolean
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/api/ntl/v1/vendor/lots/update-batch-vendor-lots-process`,
                method: 'POST',
                body: data,
                type: ContentType.FormData,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Vendor
         * @name NtlV1VendorLotsVendorLotsDataList
         * @summary Download update batch vendor lots sample file
         * @request GET:/api/ntl/v1/vendor/lots/vendor-lots-data
         */
        ntlV1VendorLotsVendorLotsDataList: (
            query?: {
                /** @default false */
                gold_atp?: boolean
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/api/ntl/v1/vendor/lots/vendor-lots-data`,
                method: 'GET',
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Vendor
         * @name NtlV1VendorSearchList
         * @summary Search catalog
         * @request GET:/api/ntl/v1/vendor/search
         */
        ntlV1VendorSearchList: (
            query: {
                /** @format uuid */
                ut: string
                /** @maxLength 100 */
                query?: string
                analytics_tag?: AnalyticsTagType
            },
            params: RequestParams = {}
        ) =>
            this.request<VendorSearchViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/v1/vendor/search`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Voucher
         * @name NtlV1VouchersUsabilityCreate
         * @request POST:/api/ntl/v1/vouchers/{code}/usability
         */
        ntlV1VouchersUsabilityCreate: (code: string, params: RequestParams = {}) =>
            this.request<CartViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/v1/vouchers/${code}/usability`,
                method: 'POST',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Wishlist
         * @name NtlV1WishlistList
         * @request GET:/api/ntl/v1/wishlist
         */
        ntlV1WishlistList: (
            query?: {
                /**
                 * @format int32
                 * @default 1
                 */
                page_number?: number
                /**
                 * @format int32
                 * @min 1
                 * @max 300
                 * @default 10
                 */
                page_size?: number
                analytics_tag?: AnalyticsTagType
            },
            params: RequestParams = {}
        ) =>
            this.request<ProductWishlistViewModelKibaPaginationViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/v1/wishlist`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Wishlist
         * @name NtlV1WishlistCreate
         * @request POST:/api/ntl/v1/wishlist
         */
        ntlV1WishlistCreate: (data: AddToWishlistRequest, params: RequestParams = {}) =>
            this.request<SuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/v1/wishlist`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Wishlist
         * @name NtlV1WishlistProductIdDelete
         * @request DELETE:/api/ntl/v1/wishlist/product-id/{product_id}
         */
        ntlV1WishlistProductIdDelete: (productId: string, params: RequestParams = {}) =>
            this.request<SuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/v1/wishlist/product-id/${productId}`,
                method: 'DELETE',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Wishlist
         * @name NtlV1WishlistProductIdDetail
         * @request GET:/api/ntl/v1/wishlist/product-id/{product_id}
         */
        ntlV1WishlistProductIdDetail: (productId: string, params: RequestParams = {}) =>
            this.request<BooleanSuccessEnvelop, FailureEnvelop>({
                path: `/api/ntl/v1/wishlist/product-id/${productId}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),
    }
}
